import { Injectable } from '@angular/core';
import { ReportsIntergrationService } from './reports-intergration.service';
import { SupabaseReportIntegrationsService } from './supabase-report-integrations.service';
import {
  CompletionTableData,
  WeeklyCourseCompletionResult,
  WeeklyEngagementResult,
  AllCoursesCompletionData,
  Dot,
  countryCoordinates,
  countryNameToCode,
  QuizPerformanceResponse,
  MAndEData,
  GraphData,
  FeedbackCardConfig,
  GetMonthlyAveragesResponse,
  AverageGraph,
  MonthlyAverage,
  MandEConfigModel,
  MAndELearnerNumberAverage,
  MoodAnalyticsData,
  MonthlyMoodActivityData
} from '../models/studentProfileModels';
import { PRE_POST_QUIZ_QUESTIONS_CONFIG } from '../models/pre-post-quiz-questions.config';
import { HttpHelperService } from './helper.service';
import {
  FeedbackRatingChartService,
  FeedbackRatingMandEChartData
} from './feedback-rating-chart.service';
import Chart from 'chart.js/auto';
import { isPlatformBrowser } from '@angular/common';
import html2canvas from 'html2canvas';
import { lastValueFrom } from 'rxjs';
import jsPDF from 'jspdf';
import { response } from 'express';
import { ValueAxisLabelLocation } from 'igniteui-angular-charts';

@Injectable({
  providedIn: 'root'
})
export class ReportsBaseService {

  selectedBot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo' | null = null;
  availableBots: { key: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo', name: string }[] = [];
  startDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  endDate: Date = new Date();
  isLoading: boolean = false;
  error: string | null = null;
  dateRange: string = '';
  //weekly engagement cards
  enrolledUsersChartData: any[] = [];
  enrolledUsersTotal: number = 0;
  enrolledUsersChangeClass: string = '';
  enrolledUsersChangeIcon: string = '';
  enrolledUsersChangePercentage: string = '';
  // course card
  courseCompletionsChartData: any[] = [];
  courseCompletionsTotal: number = 0;
  courseCompletionsChangeClass: string = '';
  courseCompletionsChangeIcon: string = '';
  courseCompletionsChangePercentage: string = '';

  usersBeganCourseChartData: any[] = [];
  usersBeganCourseTotal: number = 0;
  usersBeganCourseChangeClass: string = '';
  usersBeganCourseChangeIcon: string = '';
  usersBeganCourseChangePercentage: string = '';

  completionRateChartData: any[] = [];
  completionRateTotal: number = 0;
  completionRateChangeClass: string = '';
  completionRateChangeIcon: string = '';
  completionRateChangePercentage: string = '';
  // Quiz and Course data
  personalFinanceTableData: CompletionTableData[] = [];
  businessFinanceTableData: CompletionTableData[] = [];
  // Quiz data cards
  usersBeganQuizTotal: number = 0;
  usersBeganQuizChangeClass: string = '';
  usersBeganQuizChangeIcon: string = '';
  usersBeganQuizChangePercentage: string = '';
  quizCompletionsTotal: number = 0;
  quizCompletionsChangeClass: string = '';
  quizCompletionsChangeIcon: string = '';
  quizCompletionsChangePercentage: string = '';

  public personalUsersBeganCourseTotal: number = 0;
  public personalUsersBeganCourseChangePercentage: string = '';
  public personalUsersBeganCourseChangeIcon: string = 'remove';
  public personalUsersBeganCourseChangeClass: string = 'neutral';

  public personalCourseCompletionsTotal: number = 0;
  public personalCourseCompletionsChangePercentage: string = '';
  public personalCourseCompletionsChangeIcon: string = 'remove';
  public personalCourseCompletionsChangeClass: string = 'neutral';

  public personalCompletionRateTotal: number = 0;
  public personalCompletionRateChangePercentage: string = '';
  public personalCompletionRateChangeIcon: string = 'remove';
  public personalCompletionRateChangeClass: string = 'neutral';

  public businessUsersBeganCourseTotal: number = 0;
  public businessUsersBeganCourseChangePercentage: string = '';
  public businessUsersBeganCourseChangeIcon: string = 'remove';
  public businessUsersBeganCourseChangeClass: string = 'neutral';

  public businessCourseCompletionsTotal: number = 0;
  public businessCourseCompletionsChangePercentage: string = '';
  public businessCourseCompletionsChangeIcon: string = 'remove';
  public businessCourseCompletionsChangeClass: string = 'neutral';

  public businessCompletionRateTotal: number = 0;
  public businessCompletionRateChangePercentage: string = '';
  public businessCompletionRateChangeIcon: string = 'remove';
  public businessCompletionRateChangeClass: string = 'neutral';

  // Lesedi: path1 (Digital Literacy) / path2 (isiZulu Digital Literacy) — separate KPI & M&E state
  public lesediPath1UsersBeganCourseTotal: number = 0;
  public lesediPath1UsersBeganCourseChangePercentage: string = '';
  public lesediPath1UsersBeganCourseChangeIcon: string = 'remove';
  public lesediPath1UsersBeganCourseChangeClass: string = 'neutral';
  public lesediPath1CourseCompletionsTotal: number = 0;
  public lesediPath1CourseCompletionsChangePercentage: string = '';
  public lesediPath1CourseCompletionsChangeIcon: string = 'remove';
  public lesediPath1CourseCompletionsChangeClass: string = 'neutral';
  public lesediPath1CompletionRateTotal: number = 0;
  public lesediPath1CompletionRateChangePercentage: string = '';
  public lesediPath1CompletionRateChangeIcon: string = 'remove';
  public lesediPath1CompletionRateChangeClass: string = 'neutral';

  public lesediPath2UsersBeganCourseTotal: number = 0;
  public lesediPath2UsersBeganCourseChangePercentage: string = '';
  public lesediPath2UsersBeganCourseChangeIcon: string = 'remove';
  public lesediPath2UsersBeganCourseChangeClass: string = 'neutral';
  public lesediPath2CourseCompletionsTotal: number = 0;
  public lesediPath2CourseCompletionsChangePercentage: string = '';
  public lesediPath2CourseCompletionsChangeIcon: string = 'remove';
  public lesediPath2CourseCompletionsChangeClass: string = 'neutral';
  public lesediPath2CompletionRateTotal: number = 0;
  public lesediPath2CompletionRateChangePercentage: string = '';
  public lesediPath2CompletionRateChangeIcon: string = 'remove';
  public lesediPath2CompletionRateChangeClass: string = 'neutral';

  lesediPath1CurrentPeriodStats: QuizPerformanceResponse[] = [];
  lesediPath2CurrentPeriodStats: QuizPerformanceResponse[] = [];
  public lesediPath1MAndEResponses: MAndEData[] = [];
  public lesediPath2MAndEResponses: MAndEData[] = [];
  public lesediPath1MAndEAverages: AverageGraph[] = [];
  public lesediPath2MAndEAverages: AverageGraph[] = [];
  public lesediPath1MAndEChart: any | null = null;
  public lesediPath2MAndEChart: any | null = null;
  public lesediPath1TotalParticipants: number = 0;
  public lesediPath1TotalAverage: number = 0;
  public lesediPath1TrendPercentage: number = 0;
  public lesediPath1TrendColor: string = '';
  public lesediPath1CurrentParticipation: { participationRate: number; color: string } | null = null;
  public lesediPath1CurrentMonthMAndE: number = 0;
  public lesediPath1MAndEConfigArray: MandEConfigModel[] = [];
  public lesediPath2TotalParticipants: number = 0;
  public lesediPath2TotalAverage: number = 0;
  public lesediPath2TrendPercentage: number = 0;
  public lesediPath2TrendColor: string = '';
  public lesediPath2CurrentParticipation: { participationRate: number; color: string } | null = null;
  public lesediPath2CurrentMonthMAndE: number = 0;
  public lesediPath2MAndEConfigArray: MandEConfigModel[] = [];

  public lesediPath1PrePostChartData: any = null;
  public lesediPath2PrePostChartData: any = null;
  public lesediPath1PrePostQuizQuestionsIndexData: { quiz: string; color: string }[] = [];
  public lesediPath2PrePostQuizQuestionsIndexData: { quiz: string; color: string }[] = [];
  public lesediPath1PreQuizScoresChartData: any = null;
  public lesediPath1PostQuizScoresChartData: any = null;
  public lesediPath1OverAllEngagementChartData: any = null;
  public lesediPath1DropOffChartData: any = null;
  public lesediPath2PreQuizScoresChartData: any = null;
  public lesediPath2PostQuizScoresChartData: any = null;
  public lesediPath2OverAllEngagementChartData: any = null;
  public lesediPath2DropOffChartData: any = null;

  // Kitso AI: path1 / path2 — separate KPI & M&E state (mirrors Lesedi dual-path pattern)
  public kitsoaiPath1UsersBeganCourseTotal: number = 0;
  public kitsoaiPath1UsersBeganCourseChangePercentage: string = '';
  public kitsoaiPath1UsersBeganCourseChangeIcon: string = 'remove';
  public kitsoaiPath1UsersBeganCourseChangeClass: string = 'neutral';
  public kitsoaiPath1CourseCompletionsTotal: number = 0;
  public kitsoaiPath1CourseCompletionsChangePercentage: string = '';
  public kitsoaiPath1CourseCompletionsChangeIcon: string = 'remove';
  public kitsoaiPath1CourseCompletionsChangeClass: string = 'neutral';
  public kitsoaiPath1CompletionRateTotal: number = 0;
  public kitsoaiPath1CompletionRateChangePercentage: string = '';
  public kitsoaiPath1CompletionRateChangeIcon: string = 'remove';
  public kitsoaiPath1CompletionRateChangeClass: string = 'neutral';

  public kitsoaiPath2UsersBeganCourseTotal: number = 0;
  public kitsoaiPath2UsersBeganCourseChangePercentage: string = '';
  public kitsoaiPath2UsersBeganCourseChangeIcon: string = 'remove';
  public kitsoaiPath2UsersBeganCourseChangeClass: string = 'neutral';
  public kitsoaiPath2CourseCompletionsTotal: number = 0;
  public kitsoaiPath2CourseCompletionsChangePercentage: string = '';
  public kitsoaiPath2CourseCompletionsChangeIcon: string = 'remove';
  public kitsoaiPath2CourseCompletionsChangeClass: string = 'neutral';
  public kitsoaiPath2CompletionRateTotal: number = 0;
  public kitsoaiPath2CompletionRateChangePercentage: string = '';
  public kitsoaiPath2CompletionRateChangeIcon: string = 'remove';
  public kitsoaiPath2CompletionRateChangeClass: string = 'neutral';

  kitsoaiPath1CurrentPeriodStats: QuizPerformanceResponse[] = [];
  kitsoaiPath2CurrentPeriodStats: QuizPerformanceResponse[] = [];
  public kitsoaiPath1MAndEResponses: MAndEData[] = [];
  public kitsoaiPath2MAndEResponses: MAndEData[] = [];
  public kitsoaiPath1MAndEAverages: AverageGraph[] = [];
  public kitsoaiPath2MAndEAverages: AverageGraph[] = [];
  public kitsoaiPath1MAndEChart: any | null = null;
  public kitsoaiPath2MAndEChart: any | null = null;
  public kitsoaiPath1TotalParticipants: number = 0;
  public kitsoaiPath1TotalAverage: number = 0;
  public kitsoaiPath1TrendPercentage: number = 0;
  public kitsoaiPath1TrendColor: string = '';
  public kitsoaiPath1CurrentParticipation: { participationRate: number; color: string } | null = null;
  public kitsoaiPath1CurrentMonthMAndE: number = 0;
  public kitsoaiPath1MAndEConfigArray: MandEConfigModel[] = [];
  public kitsoaiPath2TotalParticipants: number = 0;
  public kitsoaiPath2TotalAverage: number = 0;
  public kitsoaiPath2TrendPercentage: number = 0;
  public kitsoaiPath2TrendColor: string = '';
  public kitsoaiPath2CurrentParticipation: { participationRate: number; color: string } | null = null;
  public kitsoaiPath2CurrentMonthMAndE: number = 0;
  public kitsoaiPath2MAndEConfigArray: MandEConfigModel[] = [];

  public kitsoaiPath1PrePostChartData: any = null;
  public kitsoaiPath2PrePostChartData: any = null;
  public kitsoaiPath1PrePostQuizQuestionsIndexData: { quiz: string; color: string }[] = [];
  public kitsoaiPath2PrePostQuizQuestionsIndexData: { quiz: string; color: string }[] = [];
  public kitsoaiPath1PreQuizScoresChartData: any = null;
  public kitsoaiPath1PostQuizScoresChartData: any = null;
  public kitsoaiPath1OverAllEngagementChartData: any = null;
  public kitsoaiPath1DropOffChartData: any = null;
  public kitsoaiPath2PreQuizScoresChartData: any = null;
  public kitsoaiPath2PostQuizScoresChartData: any = null;
  public kitsoaiPath2OverAllEngagementChartData: any = null;
  public kitsoaiPath2DropOffChartData: any = null;

  // Mpilo: path1 (Branch Manager) / path2 (Call Center Agent) — separate KPI & M&E state
  public mpiloPath1UsersBeganCourseTotal: number = 0;
  public mpiloPath1UsersBeganCourseChangePercentage: string = '';
  public mpiloPath1UsersBeganCourseChangeIcon: string = 'remove';
  public mpiloPath1UsersBeganCourseChangeClass: string = 'neutral';
  public mpiloPath1CourseCompletionsTotal: number = 0;
  public mpiloPath1CourseCompletionsChangePercentage: string = '';
  public mpiloPath1CourseCompletionsChangeIcon: string = 'remove';
  public mpiloPath1CourseCompletionsChangeClass: string = 'neutral';
  public mpiloPath1CompletionRateTotal: number = 0;
  public mpiloPath1CompletionRateChangePercentage: string = '';
  public mpiloPath1CompletionRateChangeIcon: string = 'remove';
  public mpiloPath1CompletionRateChangeClass: string = 'neutral';

  public mpiloPath2UsersBeganCourseTotal: number = 0;
  public mpiloPath2UsersBeganCourseChangePercentage: string = '';
  public mpiloPath2UsersBeganCourseChangeIcon: string = 'remove';
  public mpiloPath2UsersBeganCourseChangeClass: string = 'neutral';
  public mpiloPath2CourseCompletionsTotal: number = 0;
  public mpiloPath2CourseCompletionsChangePercentage: string = '';
  public mpiloPath2CourseCompletionsChangeIcon: string = 'remove';
  public mpiloPath2CourseCompletionsChangeClass: string = 'neutral';
  public mpiloPath2CompletionRateTotal: number = 0;
  public mpiloPath2CompletionRateChangePercentage: string = '';
  public mpiloPath2CompletionRateChangeIcon: string = 'remove';
  public mpiloPath2CompletionRateChangeClass: string = 'neutral';

  mpiloPath1CurrentPeriodStats: QuizPerformanceResponse[] = [];
  mpiloPath2CurrentPeriodStats: QuizPerformanceResponse[] = [];
  public mpiloPath1MAndEResponses: MAndEData[] = [];
  public mpiloPath2MAndEResponses: MAndEData[] = [];
  public mpiloPath1MAndEAverages: AverageGraph[] = [];
  public mpiloPath2MAndEAverages: AverageGraph[] = [];
  public mpiloPath1MAndEChart: any | null = null;
  public mpiloPath2MAndEChart: any | null = null;
  public mpiloPath1TotalParticipants: number = 0;
  public mpiloPath1TotalAverage: number = 0;
  public mpiloPath1TrendPercentage: number = 0;
  public mpiloPath1TrendColor: string = '';
  public mpiloPath1CurrentParticipation: { participationRate: number; color: string } | null = null;
  public mpiloPath1CurrentMonthMAndE: number = 0;
  public mpiloPath1MAndEConfigArray: MandEConfigModel[] = [];
  public mpiloPath2TotalParticipants: number = 0;
  public mpiloPath2TotalAverage: number = 0;
  public mpiloPath2TrendPercentage: number = 0;
  public mpiloPath2TrendColor: string = '';
  public mpiloPath2CurrentParticipation: { participationRate: number; color: string } | null = null;
  public mpiloPath2CurrentMonthMAndE: number = 0;
  public mpiloPath2MAndEConfigArray: MandEConfigModel[] = [];

  public mpiloPath1PrePostChartData: any = null;
  public mpiloPath2PrePostChartData: any = null;
  public mpiloPath1PrePostQuizQuestionsIndexData: { quiz: string; color: string }[] = [];
  public mpiloPath2PrePostQuizQuestionsIndexData: { quiz: string; color: string }[] = [];
  public mpiloPath1PreQuizScoresChartData: any = null;
  public mpiloPath1PostQuizScoresChartData: any = null;
  public mpiloPath1OverAllEngagementChartData: any = null;
  public mpiloPath1DropOffChartData: any = null;
  public mpiloPath2PreQuizScoresChartData: any = null;
  public mpiloPath2PostQuizScoresChartData: any = null;
  public mpiloPath2OverAllEngagementChartData: any = null;
  public mpiloPath2DropOffChartData: any = null;

  // Mpilo mood analytics (Feedback & Insight tab)
  public mpiloPath1MoodAnalytics: MoodAnalyticsData[] = [];
  public mpiloPath1MoodDistinctCount: number = 0;
  public mpiloPath1MoodTotalNumber: number = 0;
  public mpiloPath1MoodChartData: any = null;
  public mpiloPath2MoodAnalytics: MoodAnalyticsData[] = [];
  public mpiloPath2MoodDistinctCount: number = 0;
  public mpiloPath2MoodTotalNumber: number = 0;
  public mpiloPath2MoodChartData: any = null;

  // Mpilo monthly mood logging activity (Feedback & Insight tab)
  public mpiloPath1MonthlyMoodActivity: MonthlyMoodActivityData[] = [];
  public mpiloPath1MonthlyMoodActivityChartData: any = null;
  public mpiloPath2MonthlyMoodActivity: MonthlyMoodActivityData[] = [];
  public mpiloPath2MonthlyMoodActivityChartData: any = null;

  // NEW: Personal Finance
  public personalPrePostChartData: any = null;
  public personalPrePostQuizQuestions: string[] = [];

  // NEW: Business Finance
  public businessPrePostChartData: any = null;
  public businessPrePostQuizQuestions: string[] = [];

  public personalPrePostQuizChart: any | null = null;
  public personalPreQuizChart: any | null = null
  public personalPostQuizChart: any | null = null
  public personalDropOffChart: any | null = null
  public personalEngagementChart: any | null = null;
  public personalMAndEChart: any | null = null;

  public businessPrePostQuizChart: any | null = null;
  public businessPreQuizChart: any | null = null
  public businessPostQuizChart: any | null = null
  public businessDropOffChart: any | null = null
  public businessEngagementChart: any | null = null;
  public businessMAndEChart: any | null = null;

  // Pre and Post quiz data cards
  quizName: string = '';
  prequizPercentage: number = 0;
  postQuizPercentage: number = 0;
  improvement: number = 0;
  averageImprovement: number = 0;

  //M and E info
  mAndEResponses: MAndEData[] = [];
  public personalMAndEResponses: MAndEData[] = [];
  public businessMAndEResponses: MAndEData[] = [];
  currentPeriodStats: QuizPerformanceResponse[] = [];
  personalCurrentPeriodStats: QuizPerformanceResponse[] = [];
  businessCurrentPeriodStats: QuizPerformanceResponse[] = [];

  public mAndEAverages: AverageGraph[] = [];
  public mAndEAveragesTotal: number = 0;
  public fullMAndEAverages: GetMonthlyAveragesResponse[] = [];

  public totalParticipants: number = 0;
  public totalAverage: number = 0;
  mAndEAverage: number = 0;
  public trendPercentage: number = 0;
  public trendColor: string = '';
  public participationRate: number = 0;
  public currentMonthCount: number = 0;
  // Demographics
  genderData: { category: string, percentage: number, count: number }[] = [];
  ageData: { category: string, percentage: number, count: number }[] = [];
  educationData: { category: string, percentage: number, count: number }[] = [];
  incomeData: { category: string, percentage: number, count: number }[] = [];
  ethnicityData: { category: string, count: number, percentage: number }[] = [];

  sentiment1Data: { category: string, percentage: number }[] = [];
  sentiment2Data: { category: string, percentage: number }[] = [];

  educationAssistantData: { category: string, percentage: number, count: number }[] = [];
  selectedEducationAssistant: string | null = null;
  educationAssistantCategories: string[] = ['EA', 'GSA', 'Other / Neither'];
  disabilityData: { category: string, percentage: number, count: number, color?: string }[] = [];

  public countryLwaziChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth?: number;
      borderRadius?: number;
      borderSkipped?: boolean;
    }[];
  } | null = null;

  countryIndexData: { name: string, percentage: number, count: number, color: string }[] = [];
  mapDots: Dot[] = [];

  public provinceLabels: string[] = [];
  public provinceChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
      borderRadius?: number;
      borderSkipped?: boolean;
    }[];
  } | null = null;

  public provinceIndexData: { name: string; percentage: number; count: number; color: string }[] = [];

  selectedProvince: string[] = [];
  provinces: { fullName: string, abbr: string }[] =
    [
      { fullName: 'Eastern Cape', abbr: 'EC' },
      { fullName: 'Free State', abbr: 'FS' },
      { fullName: 'Gauteng', abbr: 'GT' },
      { fullName: 'KwaZulu Natal', abbr: 'KZN' },
      { fullName: 'Limpopo', abbr: 'LP' },
      { fullName: 'Mpumalanga', abbr: 'MP' },
      { fullName: 'Northern Cape', abbr: 'NC' },
      { fullName: 'North West', abbr: 'NW' },
      { fullName: 'Western Cape', abbr: 'WC' },
      { fullName: 'Not In South Africa', abbr: 'NSA' }
    ];
  public provinceMonthlyData: { [monthKey: string]: GraphData } | null = null;
  provinceColors: string[] = [];

  industries: { fullName: string, abbr: string }[] = [
    { fullName: 'Banking, Finance', abbr: 'BF' },
    { fullName: 'Food, Hospitality', abbr: 'FH' },
    { fullName: 'Sales, Marketing', abbr: 'SM' },
    { fullName: 'Retail, Wholesale', abbr: 'RW' },
    { fullName: 'Transport, Logistics', abbr: 'TL' },
    { fullName: 'Healthcare, Community', abbr: 'HC' },
    { fullName: 'Construction/Manufact.', abbr: 'CM' },
    { fullName: 'Agriculture, Mining', abbr: 'AM' },
    { fullName: 'Other', abbr: 'OT' },
    { fullName: 'Skip', abbr: 'SK' }
  ];

  selectedLanguage: string[] = [];
  public languageLabels: string[] = []; // for chart labels
  public languageChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
      borderRadius?: number;
      borderSkipped?: boolean;
    }[];
  } | null = null;

  public languageIndexData: { name: string; percentage: number; count: number; color: string }[] = [];

  languages: { fullName: string, abbr: string }[] = [
    { fullName: 'English', abbr: 'EN' },
    { fullName: 'Afrikaans', abbr: 'AF' },
    { fullName: 'isiZulu', abbr: 'ZU' },
    { fullName: 'isiXhosa', abbr: 'XH' },
    { fullName: 'Sesotho', abbr: 'ST' },
    { fullName: 'Setswana', abbr: 'TN' },
    { fullName: 'Sepedi', abbr: 'NS' },
    { fullName: 'Xitsonga', abbr: 'TS' },
    { fullName: 'SiSwati', abbr: 'SS' },
    { fullName: 'Tshivenda', abbr: 'VE' },
    { fullName: 'isiNdebele', abbr: 'NR' }
  ];

  public prePostQuizQuestions: string[] = [];
  public readonly prePostQuizBarThicknessPx = 12;
  public prePostQuizQuestionsChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
      borderRadius?: number;
      borderSkipped?: boolean;
      barThickness?: number;
    }[];
  } | null = null;

  public prePostQuizQuestionsIndexData: { quiz: string; color: string; }[] = [];
  public preQuizScoresChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;
  public preQuizScores: number[] = [];

  public postQuizScores: number[] = [];
  public postQuizScoresChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public overAllEngagementQuizScores: number[] = [];
  public overAllEngagementChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public dropOffScores: number[] = [];
  public dropOffChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public averageDropOffPercentage: number = 0;

  public businessPrePostQuizQuestionsIndexData: { quiz: string; color: string; }[] = [];
  public businessPrePostQuizQuestionsChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
      borderRadius?: number;
      borderSkipped?: boolean;
    }[];
  } | null = null;


  public businessPreQuizScoresChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;
  public businessPeQuizScores: number[] = [];

  public businessPostQuizScores: number[] = [];
  public businessPostQuizScoresChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public businessOverAllEngagementQuizScores: number[] = [];
  public businessOverAllEngagementChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public businessDropOffScores: number[] = [];
  public businessDropOffChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public businessAverageDropOffPercentage: number = 0;

  public personalPrePostQuizQuestionsIndexData: { quiz: string; color: string; }[] = [];
  public personalPrePostQuizQuestionsChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
      borderRadius?: number;
      borderSkipped?: boolean;
    }[];
  } | null = null;

  public personalPreQuizScoresChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;
  public personalPeQuizScores: number[] = [];

  public personalPostQuizScores: number[] = [];
  public personalPostQuizScoresChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public personalOverAllEngagementQuizScores: number[] = [];
  public personalOverAllEngagementChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public personalDropOffScores: number[] = [];
  public personalDropOffChartData: {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
    }[];
  } | null = null;

  public personalAverageDropOffPercentage: number = 0;

  public pieChartColor: { [key: string]: string[] } = {
    preQuiz: ['rgba(7, 154, 207, 1)'],
    postQuiz: ['rgba(117, 207, 68, 1)'],
    overAllEngagement: ['rgba(251, 142, 3, 1)'],
    dropOff: ['rgba(255, 86, 48, 1)']
  };

  displayedColumns: string[] = [
    'quizQuestion',
    'pre_learning_percentage',
    'post_learning_percentage',
    'improvement_percentage'
  ];

  //M and E question and config
  public learningFeedbackConfig: Omit<MAndEData, 'students_who_answered' | 'percentage' | 'question_text'>[] = [
    {
      title: 'Ease of Use',
      description: 'How easy learners found it to navigate the bot.',
      image: 'easeOfUseMEImage.png',
      questionMatch: 'navigate and use the bot',
      tooltipKey: 'easeOfUse',
    },
    {
      title: 'Content Relevance',
      description: 'How useful and relevant the learning content felt.',
      image: 'contentMEImage.png',
      questionMatch: 'learning content useful and relevant',
      tooltipKey: 'contentRelevance',
    },
    {
      title: 'Engagement',
      description: 'How well the bot kept learners motivated to continue.',
      image: 'engagementMEImage.png',
      questionMatch: 'keep you interested and motivated',
      tooltipKey: 'engagementFeedback',
    },
    {
      title: 'Experience',
      description: 'What learners enjoyed most about their interaction.',
      image: 'experienceMEImage.png',
      questionMatch: 'bot experience did you enjoy most',
      tooltipKey: 'experience',
    },
    {
      title: 'Improvement',
      description: 'Key areas learners feel could be improved.',
      image: 'improvementMEImage.png',
      questionMatch: 'one thing we could do to improve',
      tooltipKey: 'improvementFeedback',
    }
  ];

  public mAndEChartData: FeedbackRatingMandEChartData | null = null;

  currentTrend: { percentage: number; color: string } | null = null;
  currentParticipation: { participationRate: number; color: string } | null = null;

  public personalMAndEAverages: AverageGraph[] = [];
  public personalFullMAndEAverages: GetMonthlyAveragesResponse[] = [];
  public personalTotalParticipants: number = 0;
  public personalTotalAverage: number = 0;
  public personalTrendPercentage: number = 0;
  public personalTrendColor: string = '';
  public personalCurrentParticipation: { participationRate: number; color: string } | null = null;
  public personalMAndEConfigArray: MandEConfigModel[] = [];


  public businessMAndEAverages: AverageGraph[] = [];
  public businessFullMAndEAverages: GetMonthlyAveragesResponse[] = [];
  public businessTotalParticipants: number = 0;
  public businessTotalAverage: number = 0;
  public businessTrendPercentage: number = 0;
  public businessTrendColor: string = '';
  public businessCurrentParticipation: { participationRate: number; color: string } | null = null;
  public businessMAndEConfigArray: MandEConfigModel[] = [];
  public mAndEConfigArray: MandEConfigModel[] = [];
  currentMonthMAndE: number = 0;
  personalCurrentMonthMAndE: number = 0;
  businessCurrentMonthMAndE: number = 0;
  public mAndEConfig: MandEConfigModel[] = [];

  updateMAndEConfig(): void {
    const selectedBot = this.selectedBot;

    if (selectedBot === 'lwazi') {
      this.personalMAndEConfigArray = this.buildMAndEConfigArray(
        this.personalTotalParticipants,
        this.personalCurrentMonthMAndE,
        this.personalTotalAverage,
        this.personalCurrentParticipation,
        this.personalTrendPercentage,
        this.personalTrendColor
      );

      this.businessMAndEConfigArray = this.buildMAndEConfigArray(
        this.businessTotalParticipants,
        this.businessCurrentMonthMAndE,
        this.businessTotalAverage,
        this.businessCurrentParticipation,
        this.businessTrendPercentage,
        this.businessTrendColor
      );

      return;
    }

    if (selectedBot === 'lesedi') {
      this.lesediPath1MAndEConfigArray = this.buildMAndEConfigArray(
        this.lesediPath1TotalParticipants,
        this.lesediPath1CurrentMonthMAndE,
        this.lesediPath1TotalAverage,
        this.lesediPath1CurrentParticipation,
        this.lesediPath1TrendPercentage,
        this.lesediPath1TrendColor
      );
      this.lesediPath2MAndEConfigArray = this.buildMAndEConfigArray(
        this.lesediPath2TotalParticipants,
        this.lesediPath2CurrentMonthMAndE,
        this.lesediPath2TotalAverage,
        this.lesediPath2CurrentParticipation,
        this.lesediPath2TrendPercentage,
        this.lesediPath2TrendColor
      );
      return;
    }

    if (selectedBot === 'kitsoai') {
      this.kitsoaiPath1MAndEConfigArray = this.buildMAndEConfigArray(
        this.kitsoaiPath1TotalParticipants,
        this.kitsoaiPath1CurrentMonthMAndE,
        this.kitsoaiPath1TotalAverage,
        this.kitsoaiPath1CurrentParticipation,
        this.kitsoaiPath1TrendPercentage,
        this.kitsoaiPath1TrendColor
      );
      this.kitsoaiPath2MAndEConfigArray = this.buildMAndEConfigArray(
        this.kitsoaiPath2TotalParticipants,
        this.kitsoaiPath2CurrentMonthMAndE,
        this.kitsoaiPath2TotalAverage,
        this.kitsoaiPath2CurrentParticipation,
        this.kitsoaiPath2TrendPercentage,
        this.kitsoaiPath2TrendColor
      );
      return;
    }

    if (selectedBot === 'mpilo') {
      this.mpiloPath1MAndEConfigArray = this.buildMAndEConfigArray(
        this.mpiloPath1TotalParticipants,
        this.mpiloPath1CurrentMonthMAndE,
        this.mpiloPath1TotalAverage,
        this.mpiloPath1CurrentParticipation,
        this.mpiloPath1TrendPercentage,
        this.mpiloPath1TrendColor
      );
      this.mpiloPath2MAndEConfigArray = this.buildMAndEConfigArray(
        this.mpiloPath2TotalParticipants,
        this.mpiloPath2CurrentMonthMAndE,
        this.mpiloPath2TotalAverage,
        this.mpiloPath2CurrentParticipation,
        this.mpiloPath2TrendPercentage,
        this.mpiloPath2TrendColor
      );
      return;
    }

    // Standard bots only reach here
    this.mAndEConfigArray = this.buildMAndEConfigArray(
      this.totalParticipants,
      this.currentMonthMAndE,
      this.totalAverage,
      this.currentParticipation,
      this.trendPercentage,
      this.trendColor
    );
  }

  public prePostQuizQuestionsConfig: { [key: string]: string[] } = {
    ...PRE_POST_QUIZ_QUESTIONS_CONFIG,
  };

  employmentChartData: any[] = [];
  employmentData: { category: string, count: number, percentage: number, color: string }[] = [];
  employmentStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  employmentEndDate: Date = new Date();
  employmentColors: string[] = [];

  raceChartData: any[] = [];
  raceData: { category: string, count: number, percentage: number, color: string }[] = [];
  raceStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  raceEndDate: Date = new Date();
  raceColors: string[] = [];

  countryChartData: any[] = [];
  countryData: { category: string, count: number, percentage: number, color: string }[] = [];
  countryStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  countryEndDate: Date = new Date();
  countryColors: string[] = [];

  locationChartData: any[] = [];
  locationData: { category: string, count: number, percentage: number, color: string }[] = [];
  locationStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  locationEndDate: Date = new Date();
  locationColors: string[] = [];

  disabilityChartData: any[] = [];
  disabilityStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  disabilityEndDate: Date = new Date();
  disabilityColors: string[] = [];

  bankAccountChartData: any[] = [];
  bankAccountData: { category: string, count: number, percentage: number, color: string }[] = [];
  bankAccountStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  bankAccountEndDate: Date = new Date();
  bankAccountColors: string[] = [];

  investmentAccountChartData: any[] = [];
  investmentAccountData: { category: string, count: number, percentage: number, color: string }[] = [];
  investmentAccountStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  investmentAccountEndDate: Date = new Date();
  investmentAccountColors: string[] = [];

  employmentStatusChartData: any[] = [];
  employmentStatusData: { category: string, count: number, percentage: number, color: string }[] = [];
  employmentStatusStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  employmentStatusEndDate: Date = new Date();
  employmentStatusColors: string[] = [];

  beeiStatusChartData: any[] = [];
  beeiStatusData: { category: string, count: number, percentage: number, color: string }[] = [];
  beeiStatusStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  beeiStatusEndDate: Date = new Date();
  beeiStatusColors: string[] = [];

  yearKitsoChartData: any[] = [];
  yearKitsoData: { category: string, count: number, percentage: number, color: string }[] = [];
  yearKitsoStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  yearKitsoEndDate: Date = new Date();
  yearKitsoColors: string[] = [];

  ethnicityCheckChartData: any[] = [];
  ethnicityCheckData: { category: string, count: number, percentage: number, color: string }[] = [];
  ethnicityCheckStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  ethnicityCheckEndDate: Date = new Date();
  ethnicityCheckColors: string[] = [];

  //kitso Ecd
  kitsoUserRoleChartData: any[] = [];
  kitsoUserRoleData: { category: string, count: number, percentage: number, color: string }[] = [];
  kitsoUserRoleStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  kitsoUserRoleEndDate: Date = new Date();
  kitsoUserRoleColors: string[] = [];

  organisationECDChartData: any[] = [];
  organisationECDData: { category: string, count: number, percentage: number, color: string }[] = [];
  organisationECDStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  organisationECDEndDate: Date = new Date();
  organisationECDColors: string[] = [];

  kitsoECDRoleChartData: any[] = [];
  kitsoECDRoleData: { category: string, count: number, percentage: number, color: string }[] = [];
  kitsoECDRoleStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  kitsoECDRoleEndDate: Date = new Date();
  kitsoECDRoleColors: string[] = [];

  industryChartData: any[] = [];
  industryData: { category: string, count: number, percentage: number, color: string }[] = [];
  industryStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  industryEndDate: Date = new Date();
  industryColors: string[] = [];

  educationLwaziChartData: any[] = [];
  educationLwaziData: { category: string, count: number, percentage: number, color: string }[] = [];
  educationLwaziStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  educationLwaziEndDate: Date = new Date();
  educationLwaziColors: string[] = [];

  maritalLwaziChartData: any[] = [];
  maritalLwaziData: { category: string, count: number, percentage: number, color: string }[] = [];
  maritalLwaziStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  maritalLwaziEndDate: Date = new Date();
  maritalLwaziColors: string[] = [];

  capitecRoleChartData: any[] = [];
  capitecRoleData: { category: string, count: number, percentage: number, color: string }[] = [];
  capitecRoleStartDate: Date = new Date(new Date().setMonth(new Date().getMonth() - 1));
  capitecRoleEndDate: Date = new Date();
  capitecRoleColors: string[] = [];

  public colorPalettes: { [key: string]: string[] } = {
    province: [
      'rgb(139, 220, 92)',
      'rgb(139, 91, 177)',
      'rgb(109, 177, 255)',
      'rgb(248, 161, 95)',
      'rgb(238, 88, 121)',
      'rgb(115, 86, 86)',
      'rgb(247, 210, 98)',
      'rgb(140, 231, 217)',
      'rgb(224, 81, 169)',
      'rgb(168, 168, 183)'
    ],
    provinceZero: [
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
    ],
    language: [
      'rgb(139, 220, 92)',
      'rgb(139, 91, 177)',
      'rgb(109, 177, 255)',
      'rgb(248, 161, 95)',
      'rgb(238, 88, 121)',
      'rgb(115, 86, 86)',
      'rgb(247, 210, 98)',
      'rgb(140, 231, 217)',
      'rgb(224, 81, 169)',
      'rgb(168, 168, 183)'
    ],
    languageZero: [
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
    ],
    employment: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(88, 86, 214, 1)',
      'rgba(92, 200, 190, 1)',
      'rgba(240, 148, 54, 1)'
    ],
    race: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(88, 86, 214, 1)',
      'rgba(92, 200, 190, 1)',
      'rgba(247, 203, 69, 1)',
      'rgba(240, 148, 54, 1)',
    ],
    location: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(247, 203, 69, 1)'
    ],
    investmentAccount: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
    ],
    bankAccount: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
    ],
    employmentStatus: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(88, 86, 214, 1)',
      'rgba(92, 200, 190, 1)',
      'rgba(240, 148, 54, 1)',
      'rgba(247, 203, 69, 1)'
    ],
    beeiStatus: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)'
    ],
    yearKitso: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(247, 203, 69, 1)'
    ],
    disability: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(247, 203, 69, 1)'
    ],
    ethnicityCheck: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(88, 86, 214, 1)',
      'rgba(92, 200, 190, 1)',
      'rgba(247, 203, 69, 1)',
      'rgba(240, 148, 54, 1)',
    ],
    kitsoUserRole: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
    ],
    organisationECD: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(88, 86, 214, 1)',
      'rgba(92, 200, 190, 1)',
      'rgba(247, 203, 69, 1)',
      'rgba(240, 148, 54, 1)',
    ],
    country: [
      'rgba(217, 32, 162, 1)',
      'rgba(84, 39, 180, 1)',
      'rgba(34, 197, 94, 1)',
      'rgba(235, 182, 6, 1)',
      'rgba(179, 193, 221, 1)'
    ],
    countryZero: [
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
      'rgba(179, 193, 221, 1)',
    ],
    kitsoECDRole: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(235, 182, 6, 1)',
    ],
    industry: [
      'rgba(53, 122, 246, 1)',
      'rgba(234, 51, 84, 1)',
      'rgba(88, 86, 214, 1)',
      'rgba(92, 200, 190, 1)',
      'rgba(240, 148, 54, 1)',
      'rgba(247, 203, 69, 1)',
      'rgb(139, 91, 177)',
      'rgb(109, 177, 255)',
      'rgb(248, 161, 95)',
      'rgb(238, 88, 121)',
      'rgb(115, 86, 86)',
    ],

  };

  /**
   * Per-emotion colors matched to the Mood Breakdown design:
   * Happy gold/amber, Calm light blue, Neutral blue-grey, Low lavender,
   * Stressed coral, Frustrated terracotta, Sad steel blue.
   */
  public readonly moodEmotionColors: { [emotion: string]: string } = {
    Happy: '#E8B339',
    Calm: '#8FD0F5',
    Neutral: '#9AA8B8',
    Low: '#C4B3E8',
    Stressed: '#F0958C',
    Frustrated: '#D97240',
    Sad: '#5C7D9A',
  };

  /** Resolve bar color for API labels (handles minor casing differences). */
  moodBarColorFor(emotion: string | undefined | null): string {
    const fallback = '#B3C2D4';
    if (!emotion?.trim()) return fallback;
    const e = emotion.trim();
    const direct = this.moodEmotionColors[e];
    if (direct) return direct;
    const titled = e.charAt(0).toUpperCase() + e.slice(1).toLowerCase();
    return this.moodEmotionColors[titled] ?? fallback;
  }

  public validBotTypes: { [key: string]: string[] } = {
    lwazi: ['personal', 'business'],
    lesedi: ['path1', 'path2'],
    kitso: ['path1'],
    kitsoecd: ['path1'],
    kitsozazi: ['path1'],
    kitsoai: ['path1', 'path2'],
    mpilo: ['path1', 'path2']
  };


  constructor(
    public reportsService: ReportsIntergrationService,
    public helperService: HttpHelperService,
    public supabaseService: SupabaseReportIntegrationsService,
    private feedbackRatingChart: FeedbackRatingChartService
  ) { }



  public getPreviousPeriod(start: Date, end: Date): { prevStart: string, prevEnd: string } {
    const duration = end.getTime() - start.getTime();
    const prevEnd = new Date(start.getTime() - 1);
    const prevStart = new Date(prevEnd.getTime() - duration);
    return { prevStart: this.formatDate(prevStart), prevEnd: this.formatDate(prevEnd) };
  }

  public updateDateRange(): void {
    const formatDisplayDate = (date: Date): string => {
      const options: Intl.DateTimeFormatOptions = {
        day: 'numeric',
        month: 'long',
        year: 'numeric'
      };
      return new Intl.DateTimeFormat('en-ZA', options).format(date);
    };
    this.dateRange = `${formatDisplayDate(this.startDate)} to ${formatDisplayDate(this.endDate)}`;
  }

  public getColor(type: string, index: number): string {
    const palette = this.colorPalettes[type];
    return palette ? palette[index % palette.length] : this.generateRandomColor();
  }

  public generateRandomColor(): string {
    return '#' + Math.floor(Math.random() * 16777215).toString(16).padStart(6, '0');
  }

  public loadEngagementCount(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    currentStart: string,
    currentEnd: string,
    prevStart: string,
    prevEnd: string
  ): Promise<void> {
    return this.supabaseService.getFirstTimeEngagementCount(bot, currentStart, currentEnd).toPromise()
      .then((currentResp: { first_time_engagement_count: number } | undefined | { status?: string; message?: string }) => {

        let currentCount = 0;
        if (currentResp && 'first_time_engagement_count' in currentResp) {
          currentCount = currentResp.first_time_engagement_count ?? 0;
        } else if (currentResp && (currentResp as any).status === 'error') {
          this.error = (currentResp as any).message || 'Error in current engagement data';
        } // If undefined or invalid, remains 0
        this.enrolledUsersTotal = currentCount;
        return this.supabaseService.getFirstTimeEngagementCount(bot, prevStart, prevEnd).toPromise();
      })
      .then((prevResp: { first_time_engagement_count: number } | undefined | { status?: string; message?: string }) => {

        let previousCount = 0;
        if (prevResp && 'first_time_engagement_count' in prevResp) {
          previousCount = prevResp.first_time_engagement_count ?? 0;
        } else if (prevResp && (prevResp as any).status === 'error') {
          this.error = (prevResp as any).message || 'Error in previous engagement data';
        }
        if (this.enrolledUsersTotal === 0 && previousCount === 0) {
          this.enrolledUsersChangePercentage = '0%';
          this.enrolledUsersChangeClass = '';
          this.enrolledUsersChangeIcon = '';
        } else {
          const change = this.helperService.calculateChange(
            { labels: [this.dateRange], data: [this.enrolledUsersTotal] },
            { labels: [this.dateRange], data: [previousCount] }
          );
          this.enrolledUsersChangePercentage = change.percentage;
          this.enrolledUsersChangeClass = change.class;
          this.enrolledUsersChangeIcon = change.icon;
        }
      })
      .catch((err) => {
        console.error('Error loading first-time engagement count:', err);

        this.enrolledUsersTotal = 0;
        this.enrolledUsersChangePercentage = '0%';
        this.enrolledUsersChangeClass = '';
        this.enrolledUsersChangeIcon = '';
        throw err;
      });
  }

  public get isEnrolledUsersZeroState(): boolean {
    return this.enrolledUsersTotal === 0;
  }

  public loadCompletionStats(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    currentStart: string,
    currentEnd: string,
    prevStart: string,
    prevEnd: string
  ): Promise<void> {
    const normalizedBot = bot.toLowerCase() as 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo';
    const validBots: Array<'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo'> =
      ['lwazi', 'lesedi', 'kitso', 'kitsoecd', 'kitsozazi', 'kitsoai', 'mpilo'];

    if (!validBots.includes(normalizedBot)) {
      this.resetCompletionStatsToZero();
      return Promise.resolve();
    }

    const types = (this.validBotTypes[normalizedBot] || []) as ('personal' | 'business' | 'path1' | 'path2')[];

    const statsConfig: { subset: string[], prefix: string }[] = [];

    if (normalizedBot === 'lwazi') {
      statsConfig.push({ subset: ['business'], prefix: 'business' });
      statsConfig.push({ subset: ['personal'], prefix: 'personal' });
    } else if (normalizedBot === 'lesedi') {
      statsConfig.push({ subset: ['path1'], prefix: 'lesediPath1' });
      statsConfig.push({ subset: ['path2'], prefix: 'lesediPath2' });
    } else if (normalizedBot === 'kitsoai') {
      statsConfig.push({ subset: ['path1'], prefix: 'kitsoaiPath1' });
      statsConfig.push({ subset: ['path2'], prefix: 'kitsoaiPath2' });
    } else if (normalizedBot === 'mpilo') {
      statsConfig.push({ subset: ['path1'], prefix: 'mpiloPath1' });
      statsConfig.push({ subset: ['path2'], prefix: 'mpiloPath2' });
    } else {
      // Default behavior: Send all types, use standard variables (empty prefix)
      statsConfig.push({ subset: types, prefix: '' });
    }

    // Process all configurations in parallel
    const operations = statsConfig.map(config => {
      return this.fetchAndSumAllCoursesCompletionStats(normalizedBot, config.subset, currentStart, currentEnd)
        .then((current) => {
          return this.fetchAndSumAllCoursesCompletionStats(normalizedBot, config.subset, prevStart, prevEnd)
            .then((prev) => {
              const startedCurrent = current.started ?? 0;
              const completedCurrent = current.completed ?? 0;
              const percentageCurrent = current.percentage ?? 0;
              const startedPrev = prev.started ?? 0;
              const completedPrev = prev.completed ?? 0;
              const percentagePrev = prev.percentage ?? 0;

              // HELPER: capitalize first letter for camelCase dynamic variables
              const formatKey = (base: string) => {
                return config.prefix
                  ? `${config.prefix}${base.charAt(0).toUpperCase() + base.slice(1)}`
                  : base;
              };

              // Dynamic Variable Assignment
              (this as any)[`${formatKey('usersBeganCourse')}Total`] = startedCurrent;
              (this as any)[`${formatKey('courseCompletions')}Total`] = completedCurrent;
              (this as any)[`${formatKey('completionRate')}Total`] = percentageCurrent;

              this.setPrefixedMetricChange(startedCurrent, startedPrev, formatKey('usersBeganCourse'));
              this.setPrefixedMetricChange(completedCurrent, completedPrev, formatKey('courseCompletions'));
              this.setPrefixedMetricChange(percentageCurrent, percentagePrev, formatKey('completionRate'));
            });
        });
    });

    return Promise.all(operations)
      .then(() => {
        // All done
      })
      .catch((error) => {
        console.error('Error loading completion stats:', error);
        this.resetCompletionStatsToZero(); // You might want to update this to reset specific variables if needed
        throw error;
      });
  }


  public fetchAndSumAllCoursesCompletionStats(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    types: string[],
    start: string,
    end: string
  ): Promise<{ started: number; completed: number; percentage: number }> {

    const type = types[0] as 'personal' | 'business' | 'path1' | 'path2';

    return this.supabaseService
      .getAllCoursesCompletionStats(bot, type, start, end)
      .toPromise()
      .then((response: any) => {

        const apiData = (response && response.students_started !== undefined)
          ? response
          : (response?.data || {});


        return {
          started: apiData.students_started ?? 0,
          completed: apiData.students_completed ?? 0,
          percentage: apiData.completion_percentage ?? 0
        };
      })
      .catch((err) => {
        console.warn(`Failed to fetch stats for ${bot}/${type}:`, err);
        return { started: 0, completed: 0, percentage: 0 };
      });
  }

  public async loadPrePostQuizStats(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    start: string,
    end: string
  ): Promise<void> {
    this.isLoading = true;
    this.error = null;

    const normalizedBot = bot.toLowerCase() as 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo';
    const validBots: Array<'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo'> =
      ['lwazi', 'lesedi', 'kitso', 'kitsoecd', 'kitsozazi', 'kitsoai', 'mpilo'];

    if (!validBots.includes(normalizedBot)) {
      this.resetCompletionStatsToZero();
      this.isLoading = false;
      return;
    }

    const types = (this.validBotTypes[normalizedBot] || []) as (
      | 'personal'
      | 'business'
      | 'path1'
      | 'path2'
    )[];
    const quizConfig: { subset: string[], prefix: string }[] = [];
    const botTypes = (this.validBotTypes[normalizedBot] || []) as string[];

    if (normalizedBot === 'lwazi') {
      quizConfig.push({ subset: ['personal'], prefix: 'personal' });
      quizConfig.push({ subset: ['business'], prefix: 'business' });
    } else if (normalizedBot === 'lesedi') {
      quizConfig.push({ subset: ['path1'], prefix: 'lesediPath1' });
      quizConfig.push({ subset: ['path2'], prefix: 'lesediPath2' });
    } else if (normalizedBot === 'kitsoai') {
      quizConfig.push({ subset: ['path1'], prefix: 'kitsoaiPath1' });
      quizConfig.push({ subset: ['path2'], prefix: 'kitsoaiPath2' });
    } else if (normalizedBot === 'mpilo') {
      quizConfig.push({ subset: ['path1'], prefix: 'mpiloPath1' });
      quizConfig.push({ subset: ['path2'], prefix: 'mpiloPath2' });
    } else {
      quizConfig.push({ subset: botTypes as any, prefix: '' });
    }

    try {
      await Promise.all(quizConfig.map(async (config) => {

        // Fetch data
        const data = await this.fetchQuizPrePostStats(normalizedBot, config.subset as any, start, end);
        const validData = data.length > 0 ? data : [];

        // DYNAMIC SAVE: Saves to 'currentPeriodStats', 'personalCurrentPeriodStats', etc.
        const statsVariableName = config.prefix
          ? `${config.prefix}CurrentPeriodStats`
          : 'currentPeriodStats';

        (this as any)[statsVariableName] = validData;

      }));
    } catch (err) {
      console.error('Error loading quiz stats:', err);
      this.error = 'Failed to load quiz data';

      this.currentPeriodStats = [];
      this.personalCurrentPeriodStats = [];
      this.businessCurrentPeriodStats = [];
      this.lesediPath1CurrentPeriodStats = [];
      this.lesediPath2CurrentPeriodStats = [];
      this.kitsoaiPath1CurrentPeriodStats = [];
      this.kitsoaiPath2CurrentPeriodStats = [];
      this.mpiloPath1CurrentPeriodStats = [];
      this.mpiloPath2CurrentPeriodStats = [];
    } finally {
      this.isLoading = false;
    }
  }

  public async fetchQuizPrePostStats(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    types: ('personal' | 'business' | 'path1' | 'path2')[],
    start: string,
    end: string
  ): Promise<QuizPerformanceResponse[]> {

    const zeroQuestion: QuizPerformanceResponse = {
      quizQuestion: 'No data',
      students_who_answered_pre: '0',
      students_who_answered_post: '0',
      pre_learning_percentage: '0',
      post_learning_percentage: '0',
      improvement_percentage: '0'

    };

    const results = await Promise.all(
      types.map(type =>
        this.supabaseService.getPrePostQuizStats(bot, type, start, end)
          .toPromise()
          .catch(err => {
            console.warn(`Failed for ${bot}/${type}:`, err);
            return []; // empty on error
          })
      )
    );

    const allQuestions: QuizPerformanceResponse[] = results
      .flat()
      .map((q: any) => ({
        quizQuestion: q.question_text || 'Unknown Question',
        pre_learning_percentage: q.pre_learning_percentage || '0',
        post_learning_percentage: q.post_learning_percentage || '0',
        improvement_percentage: q.improvement_percentage || '0',
        students_who_answered_pre: q.students_who_answered_pre || '0',
        students_who_answered_post: q.students_who_answered_post || '0'
      }));
    return allQuestions.length > 0 ? allQuestions : [zeroQuestion];
  }


  isPositive(improvement: string | number): boolean {
    const value = typeof improvement === 'string' ? parseFloat(improvement) : improvement;
    return !isNaN(value) && value > 0;
  }

  isNegative(improvement: string | number): boolean {
    const value = typeof improvement === 'string' ? parseFloat(improvement) : improvement;
    return !isNaN(value) && value < 0;
  }

  // Get quiz Average Improvement
  getAverageImprovement(stats: any[] = this.currentPeriodStats): number {
    if (!stats || stats.length === 0) return 0;
    const total = stats.reduce((sum, item) => sum + (parseFloat(item.improvement_percentage) || 0), 0);
    return Number((total / stats.length).toFixed(0));
  }

  // Geting pie chart data
  getAveragePreQuizScore(stats: any[] = this.currentPeriodStats): number {
    if (!stats || stats.length === 0) return 0;
    const total = stats.reduce((sum, item) => sum + (parseFloat(item.pre_learning_percentage) || 0), 0);
    return Number((total / stats.length).toFixed(0));
  }

  getAveragePostQuizScore(stats: any[] = this.currentPeriodStats): number {
    if (!stats || stats.length === 0) return 0;
    const total = stats.reduce((sum, item) => sum + (parseFloat(item.post_learning_percentage) || 0), 0);
    return Number((total / stats.length).toFixed(0));
  }

  /**
   * Engagement rate (%) as a whole number (toFixed(0)).
   * Pass a pathway prefix to resolve `prefixUsersBeganCourseTotal` and
   * `prefixEnrolledUsersTotal` (if present) or fall back to `enrolledUsersTotal`.
   * Or pass explicit `began` and `enrolled` numbers.
   */
  public getOverallEngagementStats(
    beganOrPrefix: number | string = this.usersBeganCourseTotal,
    enrolledTotal: number = this.enrolledUsersTotal
  ): number {
    const { began, enrolled } = this.resolveEngagementInputs(beganOrPrefix, enrolledTotal);
    if (!began || !enrolled) return 0;
    return Number(((began / enrolled) * 100).toFixed(0));
  }

  public calculateDropOffStats(
    statsOrPrefix: any[] | string = this.currentPeriodStats,
    beganCourseOverride?: number
  ): number {
    const beganKey =
      typeof statsOrPrefix === 'string' ? statsOrPrefix : (beganCourseOverride ?? this.usersBeganCourseTotal);
    const { began, enrolled } = this.resolveEngagementInputs(
      beganKey,
      this.enrolledUsersTotal
    );
    if (enrolled === 0) return 0;
    return Math.round(((enrolled - began) / enrolled) * 100);
  }

  private resolveEngagementInputs(
    beganOrPrefix: number | string,
    enrolled: number
  ): { began: number; enrolled: number } {
    if (typeof beganOrPrefix === 'string') {
      const prefix = beganOrPrefix;
      const began = Number((this as any)[`${prefix}UsersBeganCourseTotal`]) || 0;
      const enrolledResolved =
        Number((this as any)[`${prefix}EnrolledUsersTotal`]) || Number(this.enrolledUsersTotal) || 0;
      return { began, enrolled: enrolledResolved };
    }
    return { began: Number(beganOrPrefix) || 0, enrolled: Number(enrolled) || 0 };
  }

  public centerTextPlugin = {
    id: 'centerText',
    beforeDraw: (chart: any) => {
      const { width, height, ctx } = chart;
      ctx.restore();

      if (!chart.data.datasets.length || chart.data.datasets[0].data.length === 0) {
        return;
      }

      const value = chart.data.datasets[0].data[0];

      // 2. Determine the Comment Text
      let commentLabel = 'Low';
      if (value >= 70) {
        commentLabel = 'Excellent';
      } else if (value >= 40) {
        commentLabel = 'Moderate';
      }

      // 3. Define Colors
      const primaryColor = 'rgba(99, 115, 129, 1)';
      const secondaryColor = 'rgba(145, 158, 171, 1)';

      ctx.textAlign = "center";
      ctx.textBaseline = "middle";


      const commentFontSize = (height / 160).toFixed(2);
      ctx.font = `normal ${commentFontSize}em roboto`;
      ctx.fillStyle = secondaryColor;


      ctx.fillText(commentLabel, width / 2, height / 2 - (height * 0.15));

      const numberFontSize = (height / 80).toFixed(2);
      ctx.font = `bold ${numberFontSize}em roboto`;
      ctx.fillStyle = primaryColor;

      // (Adjust 'height * 0.05' to move it further down if they overlap)
      ctx.fillText(value + "%", width / 2, height / 2 + (height * 0.05));

      ctx.save();
    }
  };

  // ── Shared Chart Options (used by all report components via <app-chart-js>) ──

  public provinceChartOptions: any = {
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const item = this.provinceIndexData[context.dataIndex];
            return `${item.name}: ${item.count} learners (${item.percentage}%)`;
          }
        }
      }
    },
    scales: { x: { beginAtZero: true, max: 100, ticks: { callback: (value: any) => value + '%' } } }
  };

  public languageChartOptions: any = {
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const item = this.provinceIndexData[context.dataIndex];
            return `${item.name}: ${item.count} learners (${item.percentage}%)`;
          }
        }
      }
    },
    scales: { x: { beginAtZero: true, max: 100, ticks: { callback: (value: any) => value + '%' } } }
  };

  public prePostQuizChartOptions: any = {
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (context: any) => {
            const datasetLabel = context.dataset.label || '';
            const value = context.parsed.x;
            return `${datasetLabel}: ${value}%`;
          }
        }
      }
    },
    scales: {
      x: { stacked: false, beginAtZero: true, max: 100, ticks: { callback: (value: any) => value + '%' } },
      y: {
        stacked: false,
        ticks: {
          autoSkip: false,
          stepSize: 1,
          callback: (value: any, index: any) => {
            let botKey = this.selectedBot;
            let key = '';
            const config = this.prePostQuizQuestionsConfig;
            if (!botKey) return this.prePostQuizQuestions[index] || '';
            if (!config[botKey]) { key = `${botKey}_path1`; }
            const customLabels = config[key] || [];
            return customLabels[index] || value;
          }
        }
      }
    }
  };

  public doughnutChartOptions: any = {
    cutout: '70%',
    plugins: { legend: { display: false }, tooltip: { enabled: true } }
  };

  public get mAndEChartOptions(): any {
    return this.feedbackRatingChart.mAndEChartOptions;
  }

  /**
   * Feedback Rating Over Time: delegates to {@link FeedbackRatingChartService}
   * (full month axis between {@link #startDate} and {@link #endDate}).
   */
  buildFeedbackRatingOverTimeChartData(
    averages: AverageGraph[] | null | undefined
  ): NonNullable<ReportsBaseService['mAndEChartData']> {
    return this.feedbackRatingChart.buildFeedbackRatingOverTimeChartData(
      averages,
      this.startDate,
      this.endDate
    );
  }

  /**
   * Loads the mood-analytics breakdown (per-emotion counts + overall totals)
   * for a bot/type pair. Currently wired for mpilo path1 / path2 — populates
   * the `mpiloPath{1,2}MoodAnalytics` view-state used by the Feedback & Insight tab.
   */
  public async loadMoodAnalytics(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    start: string,
    end: string
  ): Promise<void> {
    const normalizedBot = bot.toLowerCase() as typeof bot;

    const fetchForType = async (type: 'personal' | 'business' | 'path1' | 'path2'): Promise<MoodAnalyticsData[]> => {
      try {
        const data = await this.supabaseService.getMoodAnalytics(normalizedBot, type, start, end).toPromise();
        return Array.isArray(data) ? data : [];
      } catch (err) {
        console.warn(`Failed to load mood analytics for ${normalizedBot}/${type}:`, err);
        return [];
      }
    };

    try {
      if (normalizedBot === 'mpilo') {
        const [path1Data, path2Data] = await Promise.all([
          fetchForType('path1'),
          fetchForType('path2'),
        ]);
        this.applyMoodAnalytics('mpiloPath1', path1Data);
        this.applyMoodAnalytics('mpiloPath2', path2Data);
      }
    } catch (err) {
      console.error('Error loading mood analytics:', err);
      this.resetMoodAnalytics();
    }
  }

  /** Persist a mood-analytics response on `${prefix}MoodAnalytics|ChartData|DistinctCount|TotalNumber`. */
  private applyMoodAnalytics(prefix: string, data: MoodAnalyticsData[]): void {
    const safe = Array.isArray(data) ? data : [];
    (this as any)[`${prefix}MoodAnalytics`] = safe;
    (this as any)[`${prefix}MoodDistinctCount`] = safe[0]?.distinct_count ?? 0;
    (this as any)[`${prefix}MoodTotalNumber`] = safe[0]?.total_number ?? 0;
    (this as any)[`${prefix}MoodChartData`] = this.buildMoodAnalyticsChartData(safe);
  }

  /** Build chart.js horizontal-bar config from the mood analytics payload. */
  public buildMoodAnalyticsChartData(data: MoodAnalyticsData[]): any {
    if (!data || data.length === 0) return null;

    const labels = data.map(d => d.selected_emotion);
    const counts = data.map(d => Number(d.count) || 0);
    const colors = data.map(d => this.moodBarColorFor(d.selected_emotion));

    return {
      labels,
      datasets: [
        {
          label: 'Learners',
          data: counts,
          backgroundColor: colors,
          borderColor: colors,
          borderWidth: 1,
          borderRadius: 8,
          borderSkipped: false,
          barThickness: 14,
        }
      ]
    };
  }

  /** Chart.js options for the mood-analytics horizontal bar chart. */
  public readonly moodAnalyticsChartOptions: any = {
    indexAxis: 'y',
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          label: (ctx: any) => `${ctx.parsed.x} learners`,
        },
      },
    },
    scales: {
      x: { beginAtZero: true, grid: { display: false }, ticks: { display: false }, border: { display: false } },
      y: { grid: { display: false }, ticks: { color: 'rgba(52, 71, 103, 1)', font: { size: 12 } }, border: { display: false } },
    },
  };

  private resetMoodAnalytics(): void {
    this.mpiloPath1MoodAnalytics = [];
    this.mpiloPath1MoodDistinctCount = 0;
    this.mpiloPath1MoodTotalNumber = 0;
    this.mpiloPath1MoodChartData = null;
    this.mpiloPath2MoodAnalytics = [];
    this.mpiloPath2MoodDistinctCount = 0;
    this.mpiloPath2MoodTotalNumber = 0;
    this.mpiloPath2MoodChartData = null;
    this.resetMonthlyMoodActivity();
  }

  /** Chart.js options for the Monthly Mood Logging Activity bar chart. */
  public get monthlyMoodActivityChartOptions(): any {
    return this.feedbackRatingChart.monthlyMoodActivityChartOptions;
  }

  /**
   * Monthly Mood Logging Activity: delegates to {@link FeedbackRatingChartService}
   * (always produces a full Jan–Dec axis anchored on the end date's year, with
   * missing months rendered as zero-value placeholders).
   */
  buildMonthlyMoodActivityChartData(
    activity: MonthlyMoodActivityData[] | null | undefined
  ): any {
    return this.feedbackRatingChart.buildMonthlyMoodActivityChartData(
      activity,
      this.startDate,
      this.endDate
    );
  }

  /**
   * Loads the monthly mood-logging activity (per-month unique-logger counts)
   * for a bot and populates the `${prefix}MonthlyMoodActivity*` view-state
   * used by the Feedback & Insight tab. Always builds a 12-month chart, even
   * when the API returns a partial or empty set.
   */
  public async loadMonthlyMoodActivity(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    start: string,
    end: string
  ): Promise<void> {
    const normalizedBot = bot.toLowerCase() as typeof bot;

    const fetchForType = async (type: 'personal' | 'business' | 'path1' | 'path2'): Promise<MonthlyMoodActivityData[]> => {
      try {
        const data = await this.supabaseService.getMonthlyMoodActivity(normalizedBot, type, start, end).toPromise();
        return Array.isArray(data) ? data : [];
      } catch (err) {
        console.warn(`Failed to load monthly mood activity for ${normalizedBot}/${type}:`, err);
        return [];
      }
    };

    try {
      if (normalizedBot === 'mpilo') {
        const [path1Data, path2Data] = await Promise.all([
          fetchForType('path1'),
          fetchForType('path2'),
        ]);
        this.applyMonthlyMoodActivity('mpiloPath1', path1Data);
        this.applyMonthlyMoodActivity('mpiloPath2', path2Data);
      }
    } catch (err) {
      console.error('Error loading monthly mood activity:', err);
      this.resetMonthlyMoodActivity();
    }
  }

  /**
   * Persist a monthly-mood-activity response on
   * `${prefix}MonthlyMoodActivity` / `${prefix}MonthlyMoodActivityChartData`.
   * The chart is always built (even for empty arrays) so the 12-month axis
   * renders in a zero state.
   */
  private applyMonthlyMoodActivity(prefix: string, data: MonthlyMoodActivityData[]): void {
    const safe = Array.isArray(data) ? data : [];
    (this as any)[`${prefix}MonthlyMoodActivity`] = safe;
    (this as any)[`${prefix}MonthlyMoodActivityChartData`] = this.buildMonthlyMoodActivityChartData(safe);
  }

  private resetMonthlyMoodActivity(): void {
    this.mpiloPath1MonthlyMoodActivity = [];
    this.mpiloPath1MonthlyMoodActivityChartData = null;
    this.mpiloPath2MonthlyMoodActivity = [];
    this.mpiloPath2MonthlyMoodActivityChartData = null;
  }

  public async loadMAndEStats(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    start: string,
    end: string
  ): Promise<void> {
    this.isLoading = true;
    this.error = null;

    const normalizedBot = bot.toLowerCase() as 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo';
    const validBots: Array<'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo'> =
      ['lwazi', 'lesedi', 'kitso', 'kitsoecd', 'kitsozazi', 'kitsoai', 'mpilo'];

    if (!validBots.includes(normalizedBot)) {
      this.resetCompletionStatsToZero();
      this.isLoading = false;
      return;
    }

    const types = (this.validBotTypes[normalizedBot] || []) as string[];

    try {
      if (normalizedBot === 'lwazi') {

        // Fetch Personal
        await this.fetchMAndEDataStats(normalizedBot, ['personal'] as any, start, end)
          .then((personalData) => {
            this.personalMAndEResponses = personalData || [];

            // Return the next promise to continue the chain
            return this.fetchMAndEDataStats(normalizedBot, ['business'] as any, start, end);
          })
          .then((businessData) => {
            this.businessMAndEResponses = businessData || [];
          });

      } else if (normalizedBot === 'lesedi') {
        await this.fetchMAndEDataStats(normalizedBot, ['path1'] as any, start, end)
          .then((path1Data) => {
            this.lesediPath1MAndEResponses = path1Data || [];
            return this.fetchMAndEDataStats(normalizedBot, ['path2'] as any, start, end);
          })
          .then((path2Data) => {
            this.lesediPath2MAndEResponses = path2Data || [];
          });

      } else if (normalizedBot === 'kitsoai') {
        await this.fetchMAndEDataStats(normalizedBot, ['path1'] as any, start, end)
          .then((path1Data) => {
            this.kitsoaiPath1MAndEResponses = path1Data || [];
            return this.fetchMAndEDataStats(normalizedBot, ['path2'] as any, start, end);
          })
          .then((path2Data) => {
            this.kitsoaiPath2MAndEResponses = path2Data || [];
          });

      } else if (normalizedBot === 'mpilo') {
        await this.fetchMAndEDataStats(normalizedBot, ['path1'] as any, start, end)
          .then((path1Data) => {
            this.mpiloPath1MAndEResponses = path1Data || [];
            return this.fetchMAndEDataStats(normalizedBot, ['path2'] as any, start, end);
          })
          .then((path2Data) => {
            this.mpiloPath2MAndEResponses = path2Data || [];
          });

      } else {
        const data = await this.fetchMAndEDataStats(normalizedBot, types as any, start, end);
        this.mAndEResponses = data.length > 0 ? data : [];
      }

    } catch (err) {
      console.error('Error loading M and E Responses:', err);
      this.error = 'Failed to load M and E Responses';

      this.mAndEResponses = [];
      if (normalizedBot === 'lwazi') {
        this.personalMAndEResponses = [];
        this.businessMAndEResponses = [];
      }
      if (normalizedBot === 'lesedi') {
        this.lesediPath1MAndEResponses = [];
        this.lesediPath2MAndEResponses = [];
      }
      if (normalizedBot === 'kitsoai') {
        this.kitsoaiPath1MAndEResponses = [];
        this.kitsoaiPath2MAndEResponses = [];
      }
      if (normalizedBot === 'mpilo') {
        this.mpiloPath1MAndEResponses = [];
        this.mpiloPath2MAndEResponses = [];
      }
    } finally {
      this.isLoading = false;
    }
  }

  public async fetchMAndEDataStats(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    types: ('personal' | 'business' | 'path1' | 'path2')[],
    start: string,
    end: string
  ): Promise<MAndEData[]> {
    const results = await Promise.all(
      types.map(type =>
        this.supabaseService.getMAndEStats(bot, type, start, end)
          .toPromise()
          .catch(err => {
            console.warn(`Failed for ${bot}/${type}:`, err);
            return [];
          })
      )

    )

    const rawResponses: any[] = results.flat();
    const allResponses: { question_text: string; students_who_answered: number; percentage: number }[] = rawResponses
      .map((q: any) => ({
        question_text: q.question_text || 'Unknown Question',
        students_who_answered: q.students_who_answered || 0,
        percentage: q.percentage || 0,
      }));
    // Enrich config with matching data (robust to order/extra questions)
    const enriched: MAndEData[] = this.learningFeedbackConfig.map(config => {
      const matchingResponse = allResponses.find(resp =>
        resp.question_text.toLowerCase().includes(config.questionMatch.toLowerCase())
      );
      const percentage = matchingResponse?.percentage || 0;

      // Experience / Improvement are multi-option; show the most-selected
      // answer text. Percentage-based cards derive their comment from the
      // band ranges defined by the product spec.
      const isMultiOption =
        config.questionMatch === 'bot experience did you enjoy most' ||
        config.questionMatch === 'one thing we could do to improve';

      const topOption = isMultiOption
        ? this.extractTopAnswerOption(config.questionMatch, rawResponses)
        : undefined;
      const comment = isMultiOption
        ? topOption || ''
        : this.getLearnerFeedbackPercentComment(config.questionMatch, percentage);

      return {
        ...config,
        question_text: matchingResponse?.question_text,
        students_who_answered: matchingResponse?.students_who_answered || 0,
        percentage,
        topOption,
        comment,
      };
    })

    return enriched;
  }

  public async loadMAndENumber(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    start: string,
    end: string
  ): Promise<void> {
    this.isLoading = true;
    this.error = null;

    const normalizedBot = bot.toLowerCase() as typeof bot;
    const validBots = ['lwazi', 'lesedi', 'kitso', 'kitsoecd', 'kitsozazi', 'kitsoai', 'mpilo'];

    if (!validBots.includes(normalizedBot)) {
      this.resetMAndEAveragesToZero();
      this.isLoading = false;
      return;
    }

    const types = (this.validBotTypes[normalizedBot] || []) as string[];

    try {

      // 1. Define Processor (Handles Math & Assignment for both Lwazi and Standard)
      const processStats = (
        results: any[],
        prefix: string,
        statsArray: any[],
        averagesProperty?: string
      ) => {
        // A. Aggregate
        const { sumProductsMap, countsMap, monthOrder } = this.aggregateApiResults(results);

        // B. Format Graph Data
        const averagesGraphData = this.formatApiDataForGraph(sumProductsMap, countsMap, monthOrder);
        const totalParticipants = results.reduce((sum, res) => {
          const monthData = Array.isArray(res) ? res : (res?.data || []);
          return sum + monthData.reduce((monthSum: number, month: any) => {
            return monthSum + (Number(month?.completedLearners) || 0);
          }, 0);
        }, 0);

        const totalAverage = this.calculateOverallAverage(sumProductsMap, countsMap);
        // C. Trends
        const trendPct = this.calculateTrend(countsMap, monthOrder);
        const trendColor = trendPct > 0 ? 'green' : trendPct < 0 ? 'red' : 'black';
        // D. Participation Rate
        const currentMonthName = new Date().toLocaleString('en-US', { month: 'short' });
        const currentMonthMAndE = countsMap.get(currentMonthName) || 0;
        const participationObj = this.computeParticipationRate(currentMonthMAndE, statsArray);

        // E. Build Config Cards
        const configArray = this.buildMAndEConfigArray(
          totalParticipants,
          totalAverage,
          currentMonthMAndE,
          participationObj,
          trendPct,
          trendColor
        );
        const averagesKey = averagesProperty ?? `${prefix ? prefix : 'mAndE'}Averages`;
        (this as any)[averagesKey] = averagesGraphData;
        (this as any)[`${prefix ? prefix : 'mAndE'}Config`] = configArray;

        if (prefix) {
          (this as any)[`${prefix}TotalParticipants`] = totalParticipants;
          (this as any)[`${prefix}TotalAverage`] = totalAverage;
          (this as any)[`${prefix}CurrentParticipation`] = participationObj;
          (this as any)[`${prefix}TrendPercentage`] = trendPct;
          (this as any)[`${prefix}TrendColor`] = trendColor;
          (this as any)[`${prefix}CurrentMonthMAndE`] = currentMonthMAndE;
        } else {
          this.totalParticipants = totalParticipants;
          this.totalAverage = totalAverage;
          this.currentParticipation = participationObj;
          this.trendPercentage = trendPct;
          this.trendColor = trendColor;
          this.currentMonthMAndE = currentMonthMAndE;
          this.mAndEConfig = configArray;
        }
      };

      // 2. Execution Logic
      if (normalizedBot === 'lwazi') {
        // CHAIN: Fetch Personal -> Process -> Then Fetch Business -> Process
        await this.fetchMAndEAverages(normalizedBot, ['personal'] as any, start, end)
          .then((personalData) => {
            processStats(personalData, 'personal', this.personalCurrentPeriodStats, 'personalMAndEAverages');

            return this.fetchMAndEAverages(normalizedBot, ['business'] as any, start, end);
          })
          .then((businessData) => {
            processStats(businessData, 'business', this.businessCurrentPeriodStats, 'businessMAndEAverages');
          });

      } else if (normalizedBot === 'lesedi') {
        await this.fetchMAndEAverages(normalizedBot, ['path1'] as any, start, end)
          .then((path1Data) => {
            processStats(path1Data, 'lesediPath1', this.lesediPath1CurrentPeriodStats, 'lesediPath1MAndEAverages');
            return this.fetchMAndEAverages(normalizedBot, ['path2'] as any, start, end);
          })
          .then((path2Data) => {
            processStats(path2Data, 'lesediPath2', this.lesediPath2CurrentPeriodStats, 'lesediPath2MAndEAverages');
          });

      } else if (normalizedBot === 'kitsoai') {
        await this.fetchMAndEAverages(normalizedBot, ['path1'] as any, start, end)
          .then((path1Data) => {
            processStats(path1Data, 'kitsoaiPath1', this.kitsoaiPath1CurrentPeriodStats, 'kitsoaiPath1MAndEAverages');
            return this.fetchMAndEAverages(normalizedBot, ['path2'] as any, start, end);
          })
          .then((path2Data) => {
            processStats(path2Data, 'kitsoaiPath2', this.kitsoaiPath2CurrentPeriodStats, 'kitsoaiPath2MAndEAverages');
          });

      } else if (normalizedBot === 'mpilo') {
        await this.fetchMAndEAverages(normalizedBot, ['path1'] as any, start, end)
          .then((path1Data) => {
            processStats(path1Data, 'mpiloPath1', this.mpiloPath1CurrentPeriodStats, 'mpiloPath1MAndEAverages');
            return this.fetchMAndEAverages(normalizedBot, ['path2'] as any, start, end);
          })
          .then((path2Data) => {
            processStats(path2Data, 'mpiloPath2', this.mpiloPath2CurrentPeriodStats, 'mpiloPath2MAndEAverages');
          });

      } else {
        const results = await this.fetchMAndEAverages(normalizedBot, types as any, start, end);
        processStats(results, '', this.currentPeriodStats);
      }

    } catch (err) {
      console.error('Error loading M and E Averages:', err);
      this.error = 'Failed to load M and E Averages';
      this.resetMAndEAveragesToZero();
    } finally {
      this.isLoading = false;
    }
  }

  private buildMAndEConfigArray(
    total: number,
    average: number,
    currentMonthMAndE: number,
    participation: { participationRate: number, color: string } | null,
    trend: number,
    trendColor: string
  ): MandEConfigModel[] {
    const participationPct = Math.round(participation?.participationRate ?? 0);
    return [
      {
        title: 'Total Responses',
        description: 'Total Learners who rated the bot.',
        image: 'totalResponsesImage',
        numberMatch: `${currentMonthMAndE} of  ${total}`,
        tooltipKey: 'totalResponses',
        comment: this.getTotalResponsesComment(currentMonthMAndE),
      },
      {
        title: 'Average Rating',
        description: 'The combined average rating over time.',
        image: 'averageRateImage',
        numberMatch: average ? `${average} / 5` : '0 / 5',
        tooltipKey: 'averageRating',
        comment: this.getAverageRatingComment(average),
      },
      {
        title: 'Participation Rate',
        description: 'Total percentage of learners who participated.',
        image: 'participationRateImage',
        numberMatch: participation?.participationRate
          ? `${participationPct}%`
          : '0%',
        color: participation?.color,
        tooltipKey: 'participationRate',
        comment: this.getParticipationRateComment(participationPct),
      },
      {
        title: 'Engagement Trend',
        description: 'Percentage change in participation rate.',
        image: 'engagementTrendImage',
        numberMatch: (trend ?? 0).toString() + '%',
        color: trendColor,
        tooltipKey: 'engagementTrend',
        comment: this.getEngagementTrendComment(trend ?? 0),
      }
    ];
  }

  /**
   * M & E Feedback Survey – Total Responses band labels.
   * Based on volume of responses in the current month.
   */
  private getTotalResponsesComment(count: number): string {
    if (count <= 50) return 'Low response';
    if (count <= 150) return 'Moderate response';
    if (count <= 300) return 'Strong response';
    return 'High engagement';
  }

  /**
   * M & E Feedback Survey – Average Rating band labels (out of 5).
   */
  private getAverageRatingComment(average: number): string {
    const value = Number(average) || 0;
    if (value < 2) return 'Poor';
    if (value < 3) return 'Needs improvement';
    if (value < 4) return 'Moderate';
    if (value <= 4.5) return 'Positive';
    return 'Excellent';
  }

  /**
   * M & E Feedback Survey – Participation Rate band labels (percentage of
   * learners who opted in vs those who did not).
   */
  private getParticipationRateComment(percent: number): string {
    const value = Number(percent) || 0;
    if (value <= 20) return 'Very low participation';
    if (value <= 40) return 'Low participation';
    if (value <= 60) return 'Moderate participation';
    if (value <= 80) return 'Good participation';
    return 'High participation';
  }

  /**
   * M & E Feedback Survey – Engagement Trend band labels (signed % change
   * vs previous month).
   */
  private getEngagementTrendComment(trend: number): string {
    const value = Number(trend) || 0;
    if (value < -10) return 'Significant decline';
    if (value < 0) return 'Slight decline';
    if (value === 0) return 'No change';
    if (value <= 10) return 'Positive growth';
    return 'High engagement';
  }

  /**
   * Learner Feedback Summary – percentage-based cards
   * (Ease of Use, Content Relevance, Engagement).
   * Uses the `questionMatch` key so we can return the correct wording
   * for each of the three percentage metrics.
   */
  private getLearnerFeedbackPercentComment(questionMatch: string, percent: number): string {
    const value = Number(percent) || 0;
    const tier =
      value <= 20 ? 0 :
      value <= 40 ? 1 :
      value <= 60 ? 2 :
      value <= 80 ? 3 : 4;

    const copy: Record<string, [string, string, string, string, string]> = {
      'navigate and use the bot': [
        'Very difficult', 'Needs improvement', 'Neutral', 'Easy to use', 'Very positive',
      ],
      'learning content useful and relevant': [
        'Not useful', 'Needs focus', 'Somewhat useful', 'Useful', 'Highly relevant',
      ],
      'keep you interested and motivated': [
        'Very low engagement', 'Low engagement', 'Moderate engagement', 'High engagement', 'Excellent engagement',
      ],
    };

    return copy[questionMatch]?.[tier] ?? '';
  }

  /**
   * Learner Feedback Summary – dynamic comment for multi-option
   * questions (Experience / Improvement). Returns the option text that
   * was selected by the most respondents, falling back to the API
   * `question_text` if a dedicated option field isn't provided.
   */
  private extractTopAnswerOption(questionMatch: string, rawResponses: any[]): string {
    const matching = rawResponses.filter(resp =>
      (resp?.question_text || '').toLowerCase().includes(questionMatch.toLowerCase())
    );
    if (matching.length === 0) return '';

    const optionFields = [
      'top_answer_option', 'top_option', 'top_answer', 'highest_option',
      'option_text', 'answer_option', 'answer_text', 'option', 'answer',
    ];

    const pickOption = (row: any): string => {
      for (const field of optionFields) {
        if (row?.[field]) return String(row[field]);
      }
      return '';
    };

    // Prefer the row with the highest percentage when option-level data is present.
    const sorted = [...matching].sort(
      (a, b) => (Number(b?.percentage) || 0) - (Number(a?.percentage) || 0)
    );
    return pickOption(sorted[0]);
  }

  public computeParticipationRate(
    currentMonthMAndE: number,   // completedLearners for current month \
    stats: any[]                  // currentPeriodStats — pre/post quiz data
  ): { participationRate: number; color: string } | null {

    if (currentMonthMAndE == null || !stats || stats.length === 0) {
      return { participationRate: 0, color: 'rgba(30, 38, 71, 1)' };
    }

    const studentsWhoDidPostQuiz = Number(stats[0]?.students_who_answered_post || 0);

    if (studentsWhoDidPostQuiz === 0) {
      return { participationRate: 0, color: 'rgba(30, 38, 71, 1)' };
    }

    // Formula: currentMonthMAndE  / studentsWhoDidPostQuiz × 100
    const participationRate =
      ((currentMonthMAndE / studentsWhoDidPostQuiz)) * 100;

    const color = 'rgba(30, 38, 71, 1)';
    return { participationRate: Math.round(participationRate), color };
  }

  private aggregateApiResults(results: any[]) {
    let sumProductsMap = new Map<string, number>();
    let countsMap = new Map<string, number>();
    let monthOrder: string[] = [];

    results.forEach(res => {
      let monthlyData: any[] = [];
      if (Array.isArray(res)) monthlyData = res;
      else if (res && res.data && Array.isArray(res.data)) monthlyData = res.data;

      if (monthlyData.length > 0) {
        if (monthOrder.length === 0) monthOrder = monthlyData.map(m => m.month);
        monthlyData.forEach(m => {
          const score = Number(m.averageScore) || 0;
          const learners = Number(m.completedLearners) || 0;
          sumProductsMap.set(m.month, (sumProductsMap.get(m.month) || 0) + (score * learners));
          countsMap.set(m.month, (countsMap.get(m.month) || 0) + learners);
        });
      }
    });
    return { sumProductsMap, countsMap, monthOrder };
  }

  private formatApiDataForGraph(
    sumProducts: Map<string, number>,
    counts: Map<string, number>,
    months: string[]): AverageGraph[] {
    return months.map(month => {
      const prod = sumProducts.get(month) || 0;
      const count = counts.get(month) || 0;
      const avg = count > 0 ? Math.round((prod / count) * 100) / 100 : 0;
      return { month, averageScore: avg };
    });
  }

  private calculateOverallAverage(
    sumProducts: Map<string, number>, counts: Map<string, number>): number {
    let totalSumProduct = 0;
    let totalCount = 0;
    sumProducts.forEach(val => totalSumProduct += val);
    counts.forEach(val => totalCount += val);
    return totalCount > 0 ? Math.round(totalSumProduct / totalCount) : 0;
  }

  private calculateTrend(counts: Map<string, number>, monthOrder: string[]): number {
    if (monthOrder.length < 2) return 0;
    const currentMonth = monthOrder[monthOrder.length - 1];
    const previousMonth = monthOrder[monthOrder.length - 2];
    const currentLearners = counts.get(currentMonth) || 0;
    const previousLearners = counts.get(previousMonth) || 0;
    if (previousLearners > 0) {
      return Math.round(((currentLearners - previousLearners) / previousLearners) * 100);
    } else if (currentLearners > 0) {
      return 100;
    }
    return 0;
  }

  public async fetchMAndEAverages(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    types: ('personal' | 'business' | 'path1' | 'path2')[],
    start: string,
    end: string
  ): Promise<GetMonthlyAveragesResponse[]> {
    const results = await Promise.all(
      types.map(type =>
        lastValueFrom(this.supabaseService.getMAndENumbers(bot, type, start, end))
          .catch(err => {
            console.warn(`Failed to fetch M&E numbers for ${bot}/${type}:`, err);
            return { data: [], summary: { totalLearnersWhoCompleted: 0 } };
          })
      )
    );
    return results;
  }

  private resetMAndEAveragesToZero(): void {
    this.mAndEAverages = [];
    this.mAndEAveragesTotal = 0;
    this.fullMAndEAverages = [];
  }

  private resetMAndEAverageToZero(): void {
    this.mAndEAverage = 0;
  }

  public computeCurrentParticipationRate(
    currentMonthCount: number,
    statsArray: any[]
  ): { participationRate: number; color: string } | null {

    if (!currentMonthCount || !statsArray || statsArray.length === 0) {
      return null;
    }
    const totalPostAnswers = statsArray.reduce((sum, item) => sum + Number(item.students_who_answered_post || 0), 0);
    const numberOfQuestions = statsArray.length;
    if (numberOfQuestions === 0) return null;

    const estimatedTotalStudents = Math.round(totalPostAnswers / numberOfQuestions);
    let participationRate = 0;
    if (estimatedTotalStudents > 0) {
      participationRate = (currentMonthCount / estimatedTotalStudents) * 100;
    }
    const color = 'rgba(30, 38, 71, 1)';
    return { participationRate: Math.round(participationRate), color };
  }

  public setChangeValues(current: number, previous: number, prefix: string): void {
    const change = this.helperService.calculateChange(
      { labels: [this.dateRange], data: [current] },
      { labels: [this.dateRange], data: [previous] }
    );

    // CHANGED: If current and previous are 0, set percentage to '0%'
    let percentage = change.percentage;
    if (current === 0 && previous === 0) {
      percentage = '0%';
    }

    if (prefix === 'enrolledUsers') {
      this.enrolledUsersChangePercentage = percentage;
      this.enrolledUsersChangeClass = change.class;
      this.enrolledUsersChangeIcon = change.icon;
    } else if (prefix === 'usersBeganCourse') {
      this.usersBeganCourseChangePercentage = percentage;
      this.usersBeganCourseChangeClass = change.class;
      this.usersBeganCourseChangeIcon = change.icon;
    } else if (prefix === 'courseCompletions') {
      this.courseCompletionsChangePercentage = percentage;
      this.courseCompletionsChangeClass = change.class;
      this.courseCompletionsChangeIcon = change.icon;
    } else if (prefix === 'completionRate') {
      this.completionRateChangePercentage = percentage;
      this.completionRateChangeClass = change.class;
      this.completionRateChangeIcon = change.icon;
    }
  }

  /** Sets `${propertyPrefix}ChangePercentage|ChangeClass|ChangeIcon` (e.g. personalUsersBeganCourse, lesediPath1CourseCompletions). */
  public setPrefixedMetricChange(current: number, previous: number, propertyPrefix: string): void {
    const change = this.helperService.calculateChange(
      { labels: [this.dateRange], data: [current] },
      { labels: [this.dateRange], data: [previous] }
    );
    let percentage = change.percentage;
    if (current === 0 && previous === 0) {
      percentage = '0%';
    }
    (this as any)[`${propertyPrefix}ChangePercentage`] = percentage;
    (this as any)[`${propertyPrefix}ChangeClass`] = change.class;
    (this as any)[`${propertyPrefix}ChangeIcon`] = change.icon;
  }

  public resetCompletionStatsToZero(): void {

    const prefixes = ['', 'personal', 'business', 'lesediPath1', 'lesediPath2', 'kitsoaiPath1', 'kitsoaiPath2'];

    prefixes.forEach(prefix => {
      const formatKey = (base: string) => {
        return prefix
          ? `${prefix}${base.charAt(0).toUpperCase() + base.slice(1)}`
          : base;
      };

      (this as any)[`${formatKey('usersBeganCourse')}Total`] = 0;
      (this as any)[`${formatKey('courseCompletions')}Total`] = 0;
      (this as any)[`${formatKey('completionRate')}Total`] = 0;

      // Reset Change Visuals (Percentage, Class, Icon)
      ['usersBeganCourse', 'courseCompletions', 'completionRate'].forEach(metric => {
        const baseKey = formatKey(metric);
        (this as any)[`${baseKey}ChangePercentage`] = '';
        (this as any)[`${baseKey}ChangeClass`] = '';
        (this as any)[`${baseKey}ChangeIcon`] = '';
      });
    });

    this.usersBeganQuizTotal = 0;
    this.quizCompletionsTotal = 0;
    this.usersBeganQuizChangePercentage = '';
    this.usersBeganQuizChangeClass = '';
    this.usersBeganQuizChangeIcon = '';
    this.quizCompletionsChangePercentage = '';
    this.quizCompletionsChangeClass = '';
    this.quizCompletionsChangeIcon = '';
  }

  public resetCompletionStats(): void {
    this.usersBeganCourseTotal = 0;
    this.courseCompletionsTotal = 0;
    this.completionRateTotal = 0;

    this.usersBeganCourseChangePercentage = '';
    this.usersBeganCourseChangeClass = '';
    this.usersBeganCourseChangeIcon = '';
    this.courseCompletionsChangePercentage = '';
    this.courseCompletionsChangeClass = '';
    this.courseCompletionsChangeIcon = '';
    this.completionRateChangePercentage = '';
    this.completionRateChangeClass = '';
    this.completionRateChangeIcon = '';

    // Quiz reset (optional, if still shown)
    this.usersBeganQuizTotal = 0;
    this.quizCompletionsTotal = 0;
    this.usersBeganQuizChangePercentage = '';
    this.usersBeganQuizChangeClass = '';
    this.usersBeganQuizChangeIcon = '';
    this.quizCompletionsChangePercentage = '';
    this.quizCompletionsChangeClass = '';
    this.quizCompletionsChangeIcon = '';
  }

  public get isCompletionStatsZeroState(): boolean {
    return this.usersBeganCourseTotal === 0;
  }

  // loading demographics
  public loadBreakdowns(bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo', currentStart: string, currentEnd: string): Promise<void> {
    if (!this.selectedBot) {
      console.error('No bot selected');
      return Promise.reject(new Error('No bot selected'));
    }

    const breakdowns = this.botBreakdowns[this.selectedBot];
    if (!breakdowns) {
      console.error(`No breakdowns defined for bot: ${this.selectedBot}`);
      return Promise.reject(new Error(`No breakdowns defined for bot: ${this.selectedBot}`));
    }

    let promise = Promise.resolve();
    breakdowns.forEach((type) => {
      promise = promise.then(() =>
        this.fetchBreakdownData(bot, type, currentStart, currentEnd, (data) => {
          switch (type) {
            case 'Gender':
              this.genderData = data;
              break;
            case 'Age':
              this.ageData = data;
              break;
            case 'Education':
              this.educationData = data;
              break;
            case 'Income':
              this.incomeData = data;
              break;
            case 'EducationAssistant':
              this.educationAssistantData = data;
              break;
            case 'EthnicityCheck':
              this.ethnicityData = data;
              break;
            default:
              console.warn(`Unhandled breakdown type: ${type}`);
          }
        }).catch((err) => {
          console.error(`Error processing breakdown ${type}:`, err);
          return Promise.resolve(); // Continue chain

        })
      );
    });

    return promise;
  }

  public botBreakdowns: Record<'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo', string[]> = {
    lwazi: ['Age', 'Gender', 'Income', 'Education'],
    lesedi: ['Age', 'Gender', 'Income', 'EthnicityCheck'],
    kitso: ['Age', 'Gender', 'Education', 'Income'],
    kitsoecd: ['Age', 'Gender', 'Education', 'Income'],
    kitsozazi: ['Age', 'Gender', 'Education', 'Income'],
    kitsoai: ['Age', 'Gender', 'Education', 'Income'],
    mpilo: ['Age', 'Gender', 'Income', 'Education']
  };

  public getBotKey(key: string): string {
    if (!this.selectedBot) return '';
    if (this.selectedBot === 'lwazi') return `Lwazi${key}`;
    if (this.selectedBot === 'lesedi') return `Satrix${key}`;
    if (this.selectedBot === 'kitso') return `kitsoV2${key}`;
    if (this.selectedBot === 'kitsoecd') return `kitsoV2${key}`;
    if (this.selectedBot === 'kitsozazi') return `kitsoV2${key}`;
    if (this.selectedBot === 'kitsoai') return `kitsoV2${key}`;
    if (this.selectedBot === 'mpilo') return `capitecV1${key}`;
    return '';
  }

  public fetchBreakdownData(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    key: string,
    start: string,
    end: string,
    callback: (data: { category: string; percentage: number; count: number }[]) => void
  ): Promise<void> {
    let botKey = key === 'Income' && this.selectedBot === 'lesedi'
      ? 'SatrixMonthlyIncomeLevel'
      : this.getBotKey(key);

    if (!botKey) {
      console.error(`No valid bot key for ${key} on bot ${this.selectedBot}`);
      callback(this.getZeroBreakdown(key));
      return Promise.resolve();
    }

    if ((
      this.selectedBot === 'kitso' ||
      this.selectedBot === 'kitsoecd' ||
      this.selectedBot === 'kitsozazi' ||
      this.selectedBot === 'kitsoai') && botKey === 'kitsoV2Disability') {
      botKey = 'Disability';
    }
    return this.supabaseService.getProfileData(bot, botKey, start, end).toPromise()
      .then((response: any) => {
        // Handle API error responses (e.g. 400, 500) or invalid data
        const isErrorResponse =
          !response ||
          response.success === false ||
          (response.status && response.status >= 400) ||
          !response.labels ||
          !Array.isArray(response.labels) ||
          !Array.isArray(response.data) ||
          response.labels.length === 0;

        if (isErrorResponse) {
          // Capture error message if available
          if (response?.error) {
            this.error = response.error;
          } else if (response?.message) {
            this.error = response.message;
          } else {
            this.error = `No data available for ${key.toLowerCase()}.`;
          }

          console.warn(`Zero state triggered for ${key}:`, response);
          callback(this.getZeroBreakdown(key));
          return;
        }

        // Success: valid GraphData received
        let processedData: GraphData = response;
        // Bot-specific processing
        if (this.selectedBot === 'lesedi') {
          if (key === 'Gender') {
            processedData = this.processLesediGenderData(processedData);
          } else if (key === 'Age') {
            processedData = this.processLesediAgeData(processedData);
          } else if (key === 'Income') {
            processedData = this.processLesediIncomeData(processedData);
          } else if (key === 'Education') {
            processedData = this.getZeroEducationData();
          }
        } else if (key === 'Age') {
          processedData = this.groupAgeData(processedData);
        } else if (
          key === 'EducationAssistant' &&
          (this.selectedBot === 'kitso' || this.selectedBot === 'kitsoecd' || this.selectedBot === 'kitsozazi')
        ) {
          processedData = this.processEducationAssistantData(processedData);
        }

        const total = this.helperService.sumData(processedData);

        let breakdown = processedData.labels.map((label: string, index: number) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((processedData.data[index] / total) * 100),
          count: processedData.data[index]
        }));

        // If no actual data (total === 0), fall back to zero state with correct categories
        if (total === 0) {
          breakdown = this.getZeroBreakdown(key);
        }

        // Optional filtering (e.g., for EducationAssistant)
        if (key === 'EducationAssistant' && this.selectedEducationAssistant) {
          breakdown = breakdown.filter(item => item.category === this.selectedEducationAssistant);
        }

        callback(breakdown);
      })
      .catch((err: any) => {
        // Catches network errors, JSON parse errors, etc.
        console.error(`Error fetching data for ${botKey}:`, err);
        this.error = `Failed to fetch ${key.toLowerCase()} data. Please try again.`;
        callback(this.getZeroBreakdown(key));
      });
  }

  public getZeroBreakdown(key: string): { category: string, percentage: number, count: number }[] {
    let categories: string[] = [];
    switch (key) {
      case 'Gender':
        categories = ['She, Her, Hers', 'He, Him, His', 'They, Them, Theirs', 'Prefer Not To Say'];
        break;
      case 'Age':
        categories = ['18-25', '26-35', '36-46', '47+'];
        break;
      case 'Income':
        categories = ['Less than R10 000', 'Between R10k - R20k', 'Above R20 000'];
        break;
      case 'Education':
        categories = ['High School', 'Bachelor\'s', 'Master\'s', 'PhD', 'Other'];
        break;
      case 'EducationAssistant':
        categories = ['EA', 'GSA', 'Other / Neither'];
        break;
      case 'Disability':
        categories = ['Yes', 'No', 'Prefer not to say']; // Assumed categories
        break;
      default:
        categories = [];
    }
    return categories.map(cat => ({ category: cat, percentage: 0, count: 0 }));
  }

  // Processing functions (CHANGED: Ensured they return zeros with categories even on empty input)
  public processLesediGenderData(data: GraphData): GraphData {
    const displayCategories = ['She, Her, Hers', 'He, Him, His', 'They, Them, Theirs', 'Prefer Not To Say'];
    const categoryMap: { [key: string]: string } = {
      'female': 'She, Her, Hers',
      'male': 'He, Him, His',
      'non-binary': 'They, Them, Theirs',
      'other': 'They, Them, Theirs',
      'prefer not to say': 'Prefer Not To Say'
    };
    const groupedData: { [category: string]: number } = {};
    displayCategories.forEach(cat => groupedData[cat] = 0);

    data.labels.forEach((label, index) => {
      const normalizedLabel = label.toLowerCase();
      const displayCategory = categoryMap[normalizedLabel] || 'They, Them, Theirs';
      groupedData[displayCategory] += data.data[index];
    });

    return { labels: displayCategories, data: displayCategories.map(cat => groupedData[cat]) };
  }

  public processLesediAgeData(data: GraphData): GraphData {
    const displayCategories = ['18-24', '25-30', '31-35', '36-45', '46+'];
    const groupedData: { [category: string]: number } = {};
    displayCategories.forEach(cat => groupedData[cat] = 0);

    data.labels.forEach((label, index) => {
      const count = data.data[index] || 0;
      const trimmedLabel = label.trim();

      const getAgeCategory = (raw: string): string => {
        // Match range like "18 - 24", "25-30", "36 - 45"
        const rangeMatch = raw.match(/(\d+)\s*[-–]\s*(\d+)/);
        if (rangeMatch) {
          const start = parseInt(rangeMatch[1], 10);
          if (start >= 36) return '36-45';
          if (start >= 31) return '31-35';
          if (start >= 25) return '25-30';
          return '18-24';
        }

        // Match "46+" or similar
        const plusMatch = raw.match(/(\d+)\+/);
        if (plusMatch) {
          return '46+';
        }

        const singleAgeMatch = raw.match(/(\d+)/);
        if (singleAgeMatch) {
          const age = parseInt(singleAgeMatch[1], 10);
          if (age >= 46) return '46+';
          if (age >= 36) return '36-45';
          if (age >= 31) return '31-35';
          if (age >= 25) return '25-30';
          return '18-24';
        }

        return '46+';
      };

      const category = getAgeCategory(trimmedLabel);
      groupedData[category] += count;
    });

    return { labels: displayCategories, data: displayCategories.map(cat => groupedData[cat]) };
  }

  public processLesediIncomeData(data: GraphData): GraphData {
    const displayCategories = ['Less than R10 000', 'Between R10k - R20k', 'Above R20 000'];
    const groupedData: { [category: string]: number } = {};
    displayCategories.forEach(cat => groupedData[cat] = 0);

    data.labels.forEach((label, index) => {
      const count = data.data[index] || 0;
      const normalizedLabel = label.toLowerCase().replace(/[\s-_]+/g, '').trim();
      const getIncomeCategory = (label: string): string | null => {
        const singleValueMatch = label.match(/^\d+$/);
        if (singleValueMatch) {
          const value = parseInt(singleValueMatch[0], 10);
          if (value <= 10000) return 'Less than R10 000';
          if (value <= 20000) return 'Between R10k - R20k';
          return 'Above R20 000';
        }

        const rangeMatch = label.match(/(\d+)(?:to|r)?(\d+)/);
        if (rangeMatch) {
          const start = parseInt(rangeMatch[1], 10);
          const end = parseInt(rangeMatch[2], 10);
          const midpoint = (start + end) / 2;
          if (midpoint <= 10000) return 'Less than R10 000';
          if (midpoint <= 20000) return 'Between R10k - R20k';
          return 'Above R20 000';
        }

        if (label.includes('belowr5000') || label.includes('lessr4000') ||
          label.includes('idonthaveincome') || label.includes('none')) {
          return 'Less than R10 000';
        }
        if (label.includes('r10001r20000')) return 'Between R10k - R20k';
        if (label.includes('r20001r30000') || label.includes('abover30000')) {
          return 'Above R20 000';
        }

        if (!label.match(/\d/) && !label.includes('income')) return null;
        return 'Less than R10 000';
      };

      const category = getIncomeCategory(normalizedLabel);
      if (category) groupedData[category] += count;
    });

    return { labels: displayCategories, data: displayCategories.map(cat => groupedData[cat]) };
  }

  public processEducationAssistantData(data: GraphData): GraphData {
    const displayCategories = ['EA', 'GSA', 'Other / Neither'];
    const categoryMap: { [key: string]: string } = {
      'ea': 'EA',
      'Ea': 'EA',
      'gsa': 'GSA',
      'Gsa': 'GSA',
      'other / neither': 'Other / Neither',
      'Other / Neither': 'Other / Neither'
    };
    const groupedData: { [category: string]: number } = {};
    displayCategories.forEach(cat => groupedData[cat] = 0);

    data.labels.forEach((label, index) => {
      const normalizedLabel = label.toLowerCase();
      const displayCategory = categoryMap[normalizedLabel] || 'Other / Neither';
      groupedData[displayCategory] += data.data[index];
    });

    return { labels: displayCategories, data: displayCategories.map(cat => groupedData[cat]) };
  }

  public getZeroEducationData(): GraphData {
    const educationCategories = ['High School', 'Bachelor\'s', 'Master\'s', 'PhD', 'Other'];
    return {
      labels: educationCategories,
      data: new Array(educationCategories.length).fill(0)
    };
  }

  // CHANGED: Modified to always return displayCategories with zeros even on empty input
  public groupAgeData(data: GraphData): GraphData {
    const displayCategories = ['18-25', '26-35', '36-46', '47+'];
    const groupedData: { [key: string]: number } = {};
    displayCategories.forEach(cat => groupedData[cat] = 0);

    data.labels.forEach((label, index) => {
      const age = parseInt(label, 10);
      if (!isNaN(age)) {
        const group = displayCategories.find((cat, i) => {
          const [min, max] = cat.split('-').map(Number);
          return age >= min && (isNaN(max) ? true : age <= max);
        });
        if (group) groupedData[group] = (groupedData[group] || 0) + data.data[index];
      }
    });

    return { labels: displayCategories, data: displayCategories.map(cat => groupedData[cat]) };
  }

  public botLoadRemaining: Record<'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo', string[]> = {
    lwazi: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchEmploymentData',
      'fetchInstitutionChartData',
      'fetchLocationData',
      'fetchEducationChartData',
      'fetchSentimentData',
      'fetchRaceData',
      'fetchMaritalStatus'
    ],
    lesedi: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchBankAccountData',
      'fetchInvestmentAccountData',
      'fetchEmploymentStatusData',
      'fetchLocationData'
    ],
    kitso: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchLocationData',
      'fetchEmploymentData',
      'fetchBeeiStatusData',
      'fetchDisabilityData',
      'fetchKitsoUserRoleData'
    ],
    kitsoecd: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchLocationData',
      'fetchEmploymentData',
      'fetchDisabilityData',
      'fetchOrganisationECDData',
      'fetchKitsoECDRoleChartData',
      'fetchKitsoUserRoleData'
    ],
    kitsozazi: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchLocationData',
      'fetchEmploymentData',
      'fetchDisabilityData',
    ],
    kitsoai: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchLocationData',
      'fetchEmploymentData',
      'fetchDisabilityData',
    ],
    mpilo: [
      'fetchCountryData',
      'fetchProvinceData',
      'fetchLanguageData',
      'fetchLocationData',
      'fetchEmploymentData',
      'fetchCapitecRoleData',
    ]
  };


  public async loadRemainingData(currentStart: string, currentEnd: string): Promise<void> {
    const bot = this.selectedBot as 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo';


    const taskMap: { [key: string]: () => Promise<void> } = {
      // Standard Global Data (Uses current selection dates)
      'fetchCountryData': () => this.fetchCountryData(currentStart, currentEnd),
      'fetchProvinceData': () => this.fetchProvinceData(currentStart, currentEnd),
      'fetchLanguageData': () => this.fetchLanguageData(currentStart, currentEnd),

      // Lwazi Specific (Assuming standard dates if specific ones aren't defined variables)
      'fetchInstitutionChartData': () => this.fetchInstitutionData(currentStart, currentEnd),
      'fetchEducationChartData': () => this.fetchEducationData(currentStart, currentEnd),

      // Data with Specific Date Ranges (Uses class properties)
      'fetchDisabilityData': () => this.fetchDisabilityData(
        this.formatDate(this.disabilityStartDate), this.formatDate(this.disabilityEndDate)),

      'fetchEmploymentData': () => this.fetchEmploymentData(
        this.formatDate(this.employmentStartDate), this.formatDate(this.employmentEndDate)),

      'fetchRaceData': () => this.fetchRaceData(
        this.formatDate(this.raceStartDate), this.formatDate(this.raceEndDate)),

      'fetchLocationData': () => this.fetchLocationData(
        this.formatDate(this.locationStartDate), this.formatDate(this.locationEndDate)),

      'fetchBankAccountData': () => this.fetchBankAccountData(
        this.formatDate(this.bankAccountStartDate), this.formatDate(this.bankAccountEndDate)),

      'fetchInvestmentAccountData': () => this.fetchInvestmentAccountData(
        this.formatDate(this.investmentAccountStartDate), this.formatDate(this.investmentAccountEndDate)),

      'fetchEmploymentStatusData': () => this.fetchEmploymentStatusData(
        this.formatDate(this.employmentStatusStartDate), this.formatDate(this.employmentStatusEndDate)),

      'fetchBeeiStatusData': () => this.fetchBEEIStatusData(
        this.formatDate(this.beeiStatusStartDate), this.formatDate(this.beeiStatusEndDate)),

      'fetchYearKitsoData': () => this.fetchYearKitsoData(
        this.formatDate(this.yearKitsoStartDate), this.formatDate(this.yearKitsoEndDate)),

      'fetchKitsoUserRoleData': () => this.fetchKitsoUserRoleData(
        this.formatDate(this.kitsoUserRoleStartDate), this.formatDate(this.kitsoUserRoleEndDate)),

      'fetchOrganisationECDData': () => this.fetchOrganisationECDData(
        this.formatDate(this.organisationECDStartDate), this.formatDate(this.organisationECDEndDate)),

      'fetchKitsoECDRoleChartData': () => this.fetchKitsoECDRoleChartData(
        this.formatDate(this.kitsoECDRoleStartDate), this.formatDate(this.kitsoECDRoleEndDate)),
      'fetchSentimentData': () => this.fetchSentimentData(currentStart, currentEnd),
      'fetchCapitecRoleData': () => this.fetchCapitecRoleData(currentStart, currentEnd),
      'fetchMaritalStatus': () => this.fetchMaritalStatus(currentStart, currentEnd),
    };

    // 1. Get the list of functions to run for the current bot
    const tasksToRunNames = this.botLoadRemaining[bot] || [];

    // 2. Iterate and execute sequentially
    for (const taskName of tasksToRunNames) {
      const task = taskMap[taskName];
      if (task) {
        await task();
      } else {
        console.warn(`Task '${taskName}' not found in taskMap for bot '${bot}'`);
      }
    }
  }

  public fetchCountryData(start: string, end: string): Promise<void> {
    // 1. Remove isLoading to match [B] logic
    let botKey = this.getBotKey('Country');

    if (!this.selectedBot || !botKey) {
      this.setCountryZeroState();
      return Promise.resolve();
    }

    if (['kitso', 'kitsoecd', 'kitsozazi', 'kitsoai'].includes(this.selectedBot) && botKey === 'kitsoV2Country') {
      botKey = 'Country';
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        // Validation (Kept your sumData check as requested to preserve ZeroState logic)
        if (!data || !Array.isArray(data.labels) || data.labels.length === 0 || this.helperService.sumData(data) === 0 || (data as any).status === 'error') {
          this.setCountryZeroState();
          return;
        }
        const total = this.helperService.sumData(data);


        const colors = data.labels.map((_, i) => this.getColor('country', i));
        this.countryColors = colors;


        this.countryChartData = data.labels
          .map((label, i) => ({
            category: label,
            percentage: total > 0 ? Math.round((data.data[i] / total) * 100) : 0,
            color: ''
          }))
          .sort((a, b) => b.percentage - a.percentage)
          .map((item, i) => ({
            ...item,
            color: this.getColor('country', i)
          }));

        this.countryIndexData = data.labels.map((label, i) => ({
          name: label,
          count: data.data[i],
          percentage: total > 0 ? Math.round((data.data[i] / total) * 100) : 0,
          color: colors[i]
        }));
        const Color = '#ffffff';
        this.countryLwaziChartData = {
          labels: this.countryIndexData.map(item => item.name),
          datasets: [{
            label: '',
            data: this.countryIndexData.map(item => item.percentage),
            backgroundColor: this.countryIndexData.map(item => item.color),
            borderColor: [Color]

          }]
        };

        this.countryData = data.labels.map((label, i) => ({
          category: label,
          count: data.data[i],
          percentage: total > 0 ? Math.round((data.data[i] / total) * 100) : 0,
          color: colors[i]
        }));
      })
      .catch((err) => {
        console.error(`Country fetch error for bot ${this.selectedBot}:`, err);
        this.setCountryZeroState();
      });
  }

  private setCountryZeroState(): void {
    const greyColor = 'rgba(179, 193, 221, 1)';
    const darkGrey = 'rgba(179, 193, 221, 1)';  // Darker grey for the "No Data" segment

    this.countryColors = [greyColor, greyColor, greyColor, darkGrey];

    // Chart Data: Renders a full grey circle (100% No Data)
    this.countryChartData = [
      { category: 'South Africa', percentage: 0 },
      { category: 'Nigeria', percentage: 0 },
      { category: 'Kenya', percentage: 0 },
      { category: 'No Data', percentage: 100 },
    ];

    // Standard Data: List view
    this.countryData = [
      { category: 'South Africa', count: 0, percentage: 0, color: greyColor },
      { category: 'Nigeria', count: 0, percentage: 0, color: greyColor },
      { category: 'Kenya', count: 0, percentage: 0, color: greyColor },
      { category: 'No Data', count: 0, percentage: 100, color: darkGrey },
    ];

    // Index Data: For specific tables that use 'name' instead of 'category'
    this.countryIndexData = [
      { name: 'South Africa', count: 0, percentage: 0, color: greyColor },
      { name: 'Nigeria', count: 0, percentage: 0, color: greyColor },
      { name: 'Kenya', count: 0, percentage: 0, color: greyColor },
      { name: 'No Data', count: 0, percentage: 100, color: darkGrey },
    ];
  }

  public fetchProvinceData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('Province');
    if (!this.selectedBot || !botKey) {
      this.provinceIndexData = this.getZeroProvinceIndexData();
      this.provinceChartData = null;
      return Promise.resolve();
    }

    return this.supabaseService
      .getProfileData(this.selectedBot, botKey, start, end)
      .toPromise()
      .then((response: GraphData | undefined) => {
        // No data or empty → zero state
        if (!response || !response.labels || response.labels.length === 0) {
          this.provinceIndexData = this.getZeroProvinceIndexData();
          this.provinceChartData = null;
          return;
        }
        const total = response.data.reduce((sum, val) => sum + (val || 0), 0);

        // Build a lookup from the API response
        const apiDataMap = new Map<string, number>();
        response.labels.forEach((label: string, i: number) => {
          apiDataMap.set(label, response.data[i] || 0);
        });

        // Build index data for ALL provinces (even those with 0)
        this.provinceIndexData = this.provinces.map((p, i) => {
          const count = apiDataMap.get(p.fullName) || 0;
          return {
            name: p.fullName,
            count: count,
            percentage: total === 0 ? 0 : Math.round((count / total) * 100),
            color: this.getColor('province', i)
          };
        });
        // Sort by count descending
        this.provinceIndexData.sort((a, b) => b.count - a.count);

        // Build chart data from API datapoints only (non-zero)
        const apiProvinceData = response.labels.map((label: string, i: number) => {
          const provIndex = this.provinces.findIndex(p => p.fullName === label);
          const count = response.data[i] || 0;
          return {
            name: label,
            count: count,
            percentage: total === 0 ? 0 : Math.round((count / total) * 100),
            color: this.getColor('province', provIndex >= 0 ? provIndex : i)
          };
        });
        apiProvinceData.sort((a, b) => b.count - a.count);

        this.provinceChartData = {
          labels: apiProvinceData.map(item => item.name),
          datasets: [{
            label: 'Learners by Province (%)',
            data: apiProvinceData.map(item => item.percentage),
            backgroundColor: apiProvinceData.map(item => item.color + 'cc'), // 80% opacity
            borderColor: apiProvinceData.map(item => item.color),
            borderWidth: 2,
            borderRadius: 6,
            borderSkipped: false,
          }]
        };
        this.updateProvinceChartForFilter();
      })
      .catch(err => {
        console.error('Error fetching province data:', err);
        this.provinceIndexData = this.getZeroProvinceIndexData();
        this.provinceChartData = null;
      });
  }

  public updateProvinceChartForFilter(): void {
    if (!this.provinceIndexData || this.provinceIndexData.length === 0) {
      this.provinceChartData = null;
      return;
    }

    // Start with only non-zero data for the chart (API datapoints only)
    let filteredData = this.provinceIndexData.filter(p => p.count > 0);

    // If provinces are selected → show only those that have data
    if (this.selectedProvince.length > 0) {
      filteredData = this.provinceIndexData
        .filter(p => this.selectedProvince.includes(p.name) && p.count > 0);

      filteredData.sort((a, b) => b.count - a.count);
    }

    this.provinceChartData = {
      labels: filteredData.map(item => item.name),
      datasets: [{
        label: this.selectedProvince.length > 0
          ? (this.selectedProvince.length === 1
            ? `${this.selectedProvince[0]} Learners (%)`
            : 'Selected Provinces (%)')
          : 'Learners by Province (%)',
        data: filteredData.map(item => item.percentage),
        backgroundColor: filteredData.map(item => item.color + 'cc'),
        borderColor: filteredData.map(item => item.color),
        borderWidth: 2,
        borderRadius: 6,
        borderSkipped: false,
      }]
    };
  }

  public getZeroProvinceIndexData(): { name: string; percentage: number; count: number; color: string }[] {
    return this.provinces.map((p, i) => ({
      name: p.fullName,
      count: 0,
      percentage: 0,
      color: this.getColor('provinceZero', i)
    }));
  }

  public fetchLanguageData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('Language');
    if (!this.selectedBot || !botKey) {
      this.languageIndexData = this.getZeroLanguageIndexData();
      this.languageChartData = this.getZeroChartData('language');
      return Promise.resolve();
    }

    return this.supabaseService
      .getProfileData(this.selectedBot, botKey, start, end)
      .toPromise()
      .then((response: GraphData | undefined) => {
        // No data or empty → zero state with empty chart
        if (!response || !response.labels || response.labels.length === 0) {
          this.languageIndexData = this.getZeroLanguageIndexData();
          this.languageChartData = this.getZeroChartData('language');
          return;
        }
        const total = response.data.reduce((sum, val) => sum + (val || 0), 0);

        // Build a lookup from the API response
        const apiDataMap = new Map<string, number>();
        response.labels.forEach((label: string, i: number) => {
          apiDataMap.set(label, response.data[i] || 0);
        });

        // Build index data for ALL languages (even those with 0)
        this.languageIndexData = this.languages.map((l, i) => {
          const count = apiDataMap.get(l.fullName) || 0;
          return {
            name: l.fullName,
            count: count,
            percentage: total === 0 ? 0 : Math.round((count / total) * 100),
            color: this.getColor('language', i)
          };
        });
        // Sort by count descending
        this.languageIndexData.sort((a, b) => b.count - a.count);

        // Build chart data from API datapoints only (non-zero)
        const apiLanguageData = response.labels.map((label: string, i: number) => {
          const langIndex = this.languages.findIndex(l => l.fullName === label);
          const count = response.data[i] || 0;
          return {
            name: label,
            count: count,
            percentage: total === 0 ? 0 : Math.round((count / total) * 100),
            color: this.getColor('language', langIndex >= 0 ? langIndex : i)
          };
        });
        apiLanguageData.sort((a, b) => b.count - a.count);

        // Build Chart.js data
        this.languageChartData = {
          labels: apiLanguageData.map(item => item.name),
          datasets: [{
            label: 'Learners by Language (%)',
            data: apiLanguageData.map(item => item.percentage),
            backgroundColor: apiLanguageData.map(item => item.color + 'cc'),
            borderColor: apiLanguageData.map(item => item.color),
            borderWidth: 2,
            borderRadius: 6,
            borderSkipped: false,
          }]
        };
        this.updateLanguageChartForFilter();
      })
      .catch(err => {
        console.error('Error fetching language data:', err);
        this.languageIndexData = this.getZeroLanguageIndexData();
        this.languageChartData = this.getZeroChartData('language');
      });
  }

  public updateLanguageChartForFilter(): void {
    if (!this.languageIndexData || this.languageIndexData.length === 0) {
      this.languageChartData = this.getZeroChartData('language');
      return;
    }

    // Start with only non-zero data for the chart (API datapoints only)
    let filteredData = this.languageIndexData.filter(l => l.count > 0);

    // If languages are selected → show only those that have data
    if (this.selectedLanguage && this.selectedLanguage.length > 0) {
      filteredData = this.languageIndexData
        .filter(l => this.selectedLanguage.includes(l.name) && l.count > 0);
      filteredData.sort((a, b) => b.count - a.count);
    }

    // Rebuild Chart.js data
    this.languageChartData = {
      labels: filteredData.map(item => item.name),
      datasets: [{
        label: this.selectedLanguage && this.selectedLanguage.length > 0
          ? 'Selected Languages (%)'
          : 'Learners by Language (%)',
        data: filteredData.map(item => item.percentage),
        backgroundColor: filteredData.map(item => item.color + 'cc'),
        borderColor: filteredData.map(item => item.color),
        borderWidth: 2,
        borderRadius: 6,
        borderSkipped: false,
      }]
    };
  }

  // NEW: Added zero state for language index data
  public getZeroLanguageIndexData(): { name: string; percentage: number; count: number; color: string }[] {
    return this.languages.map((l, i) => ({
      name: l.fullName,
      count: 0,
      percentage: 0,
      color: this.getColor('provinceZero', i)  // Reuse colors
    }));
  }

  /**
 * Returns a Chart.js data object with ALL values = 0
 * Used for "zero state" — shows an empty chart instead of hiding it
 */
  public getZeroChartData(
    type: 'province' | 'language' // add more if needed
  ): {
    labels: string[];
    datasets: {
      label: string;
      data: number[];
      backgroundColor: string[];
      borderColor: string[];
      borderWidth: number;
      borderRadius: number;
      borderSkipped: boolean;
    }[];
  } {
    let zeroItems: { name: string; color: string }[] = [];

    // Choose the correct list + color palette
    switch (type) {
      case 'province':
        zeroItems = this.provinces.map((p, i) => ({
          name: p.fullName,
          color: this.getColor('province', i)
        }));
        break;
      case 'language':
        zeroItems = this.languages.map((l, i) => ({
          name: l.fullName,
          color: this.getColor('province', i) // or create 'language' palette if you want
        }));
        break;
      // add more cases if you have other breakdowns
      default:
        zeroItems = [];
    }

    return {
      labels: zeroItems.map(item => item.name),
      datasets: [{
        label: `Learners by ${type.charAt(0).toUpperCase() + type.slice(1)} (%)`,
        data: zeroItems.map(() => 0),                    // ← all zeros
        backgroundColor: zeroItems.map(item => item.color + 'cc'), // 80% opacity
        borderColor: zeroItems.map(item => item.color),
        borderWidth: 2,
        borderRadius: 6,
        borderSkipped: false,
      }]
    };
  }

  // CHANGED: Added zero state for employment
  public getZeroEmploymentData(): { category: string, count: number, percentage: number, color: string }[] {
    const defaultCategories = ['Employed', 'Unemployed', 'Self-Employed', 'Student', 'Retired']; // Assumed based on common employment types
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('employment', index)
    }));
  }

  public fetchEmploymentData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('Employment');
    if (!this.selectedBot || !botKey) {
      this.setEmploymentZeroState();
      return Promise.resolve();
    }
    if (this.selectedBot === 'lesedi') botKey = 'SatrixEmploymentStatus';
    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || !Array.isArray(data.labels) || data.labels.length === 0 || this.helperService.sumData(data) === 0) {
          this.setEmploymentZeroState();
          return;
        }
        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, i) => this.getColor('employmentStatus', i));

        this.employmentColors = colors;

        this.employmentChartData = data.labels.map((label, i) => ({
          category: label,
          percentage: Math.round((data.data[i] / total) * 100)
        }));

        this.employmentData = data.labels.map((label, i) => ({
          category: label,
          count: data.data[i],
          percentage: Math.round((data.data[i] / total) * 100),
          color: colors[i]
        }))
      })
      .catch(err => {
        console.error('Employment fetch error:', err);
        this.setEmploymentZeroState();
      });
  }

  // NEW: Real zero state with greyed-out look
  private setEmploymentZeroState(): void {
    const greyColor = 'rgba(179, 193, 221, 1)';
    const darkGrey = 'rgba(179, 193, 221, 1)';

    this.employmentColors = [
      greyColor,
      greyColor,
      greyColor,
      greyColor,
      greyColor,
      greyColor,
      darkGrey];

    // Keep real data structure so pie chart renders
    this.employmentChartData = [
      { category: 'Full Employment', percentage: 0 },
      { category: 'Part Time', percentage: 0 },
      { category: 'Self Employed', percentage: 0 },
      { category: 'Unemployed - Looking', percentage: 0 },
      { category: 'Unemployed - Not Looking', percentage: 0 },
      { category: 'Other', percentage: 0 },
      { category: 'No Data', percentage: 100 }
    ];

    this.employmentData = [
      { category: 'Full Employment', count: 0, percentage: 0, color: greyColor },
      { category: 'Part Time', count: 0, percentage: 0, color: greyColor },
      { category: 'Self Employed', count: 0, percentage: 0, color: greyColor },
      { category: 'Unemployed - Looking', count: 0, percentage: 0, color: greyColor },
      { category: 'Unemployed - Not Looking', count: 0, percentage: 0, color: greyColor },
      { category: 'Other', count: 0, percentage: 0, color: greyColor },
      { category: 'No Data', count: 0, percentage: 100, color: greyColor }
    ];
  }

  public fetchRaceData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('Race');
    if (!this.selectedBot || !botKey) {
      // CHANGED: Set zero state
      this.raceChartData = [];
      this.raceData = this.getZeroRaceData();
      this.raceColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        // CHANGED: Handle zero-data or error
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.raceChartData = [];
          this.raceData = this.getZeroRaceData();
          this.raceColors = [];
        } else {
          const total = this.helperService.sumData(data);
          const colors = data.labels.map((_, index) => this.getColor('race', index));

          this.raceColors = colors;
          this.raceChartData = data.labels.map((label, index) => ({
            category: label,
            percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          }));

          this.raceData = data.labels.map((label, index) => ({
            category: label,
            count: data.data[index],
            percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
            color: colors[index]
          }));

          // CHANGED: If total === 0, set to zero state
          if (total === 0) {
            this.raceChartData = [];
            this.raceData = this.getZeroRaceData();
            this.raceColors = [];
          }
        }
      })
      .catch((err) => {
        console.error(`Error fetching race data of bot ${this.selectedBot}:`, err);
        this.raceChartData = [];
        this.raceData = this.getZeroRaceData();
        this.raceColors = [];
      });
  }

  // CHANGED: Added zero state for race
  public getZeroRaceData(): { category: string, count: number, percentage: number, color: string }[] {
    const defaultCategories = ['Black', 'White', 'Coloured', 'Indian/Asian', 'Other', 'Prefer not to say']; // Assumed common races in context
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('race', index)
    }));
  }


  public fetchLocationData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('LocationType');
    if (!this.selectedBot || !botKey) {
      this.setLocationZeroState();
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || !Array.isArray(data.labels) || data.labels.length === 0 || this.helperService.sumData(data) === 0) {
          this.setLocationZeroState();
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, i) => this.getColor('location', i));

        this.locationColors = colors;

        this.locationChartData = data.labels.map((label, i) => ({
          category: label,
          percentage: Math.round((data.data[i] / total) * 100)
        }));

        this.locationData = data.labels.map((label, i) => ({
          category: label,
          count: data.data[i],
          percentage: Math.round((data.data[i] / total) * 100),
          color: colors[i]
        }));
      })
      .catch(err => {
        console.error('Location fetch error:', err);
        this.setLocationZeroState();
      });
  }

  // NEW: Real zero state with greyed-out look
  private setLocationZeroState(): void {
    const greyColor = 'rgba(179, 193, 221, 1)';
    const darkGrey = 'rgba(179, 193, 221, 1)';

    this.locationColors = [greyColor, greyColor, greyColor];

    // Keep real data structure so pie chart renders
    this.locationChartData = [
      { category: 'Urban', percentage: 0 },
      { category: 'Rural', percentage: 0 },
      { category: 'Suburban', percentage: 0 },
      { category: 'No Data', percentage: 100 },
    ];

    this.locationData = [
      { category: 'Urban', count: 0, percentage: 0, color: greyColor },
      { category: 'Rural', count: 0, percentage: 0, color: greyColor },
      { category: 'Suburban', count: 0, percentage: 0, color: greyColor },
      { category: 'No Data', count: 100, percentage: 100, color: greyColor },
    ];
  }


  public fetchDisabilityData(start: string, end: string): Promise<void> {
    let botKey = 'Disability';
    if (!this.selectedBot || !botKey) {
      this.setDisabilityZeroState();
      return Promise.resolve();
    }
    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || !Array.isArray(data.labels) || data.labels.length === 0 || this.helperService.sumData(data) === 0) {
          this.setDisabilityZeroState();
          return;
        }
        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, i) => this.getColor('disability', i));

        this.disabilityColors = colors;

        this.disabilityChartData = data.labels.map((label, i) => ({
          category: label,
          percentage: Math.round((data.data[i] / total) * 100)
        }));

        this.disabilityData = data.labels.map((label, i) => ({
          category: label,
          count: data.data[i],
          percentage: Math.round((data.data[i] / total) * 100),
          color: colors[i]
        }))
      })
      .catch(err => {
        console.error('Disability fetch error:', err);
        this.setDisabilityZeroState();
      });

  }

  private setDisabilityZeroState(): void {
    const greyColor = 'rgba(179, 193, 221, 1)';

    this.disabilityColors = [greyColor, greyColor, greyColor, greyColor];

    // Keep real data structure so pie chart renders
    this.disabilityChartData = [
      { category: 'Yes', percentage: 0 },
      { category: 'No', percentage: 0 },
      { category: 'Prefer Not to say', percentage: 0 },
      { category: 'No Data', percentage: 100 }
    ];
    this.disabilityData = [
      { category: 'Yes', count: 0, percentage: 0, color: greyColor },
      { category: 'No', count: 0, percentage: 0, color: greyColor },
      { category: 'Prefer Not to say', count: 0, percentage: 0, color: greyColor },
      { category: 'No Data', count: 100, percentage: 100, color: greyColor }
    ];
  }

  public fetchBankAccountData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('BankAccount');
    if (!this.selectedBot || !botKey) {
      // CHANGED: Set zero state
      this.bankAccountChartData = [];
      this.bankAccountData = this.getZeroBankAccountData();
      this.bankAccountColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        // CHANGED: Handle zero-data or error
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.bankAccountChartData = [];
          this.bankAccountData = this.getZeroBankAccountData();
          this.bankAccountColors = [];
        } else {
          const total = this.helperService.sumData(data);
          const colors = data.labels.map((_, index) => this.getColor('bankAccount', index));

          this.bankAccountColors = colors;
          this.bankAccountChartData = data.labels.map((label, index) => ({
            category: label,
            percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          }));

          this.bankAccountData = data.labels.map((label, index) => ({
            category: label,
            count: data.data[index],
            percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
            color: colors[index]
          }));

          // CHANGED: If total === 0, set to zero state
          if (total === 0) {
            this.bankAccountChartData = [];
            this.bankAccountData = this.getZeroBankAccountData();
            this.bankAccountColors = [];
          }
        }
      })
      .catch((err) => {
        console.error(`Error fetching bank account data of ${this.selectedBot}:`, err);
        this.bankAccountChartData = [];
        this.bankAccountData = this.getZeroBankAccountData();
        this.bankAccountColors = [];
      });
  }

  // CHANGED: Added zero state for bank account
  public getZeroBankAccountData(): { category: string, count: number, percentage: number, color: string }[] {
    const defaultCategories = ['Yes', 'No']; // Assumed yes/no for having bank account
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('bankAccount', index)
    }));
  }

  public fetchInvestmentAccountData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('InvestmentAccount');
    if (!this.selectedBot || !botKey) {
      // CHANGED: Set zero state
      this.investmentAccountChartData = [];
      this.investmentAccountData = this.getZeroInvestmentAccountData();
      this.investmentAccountColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        // CHANGED: Handle zero-data or error
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.investmentAccountChartData = [];
          this.investmentAccountData = this.getZeroInvestmentAccountData();
          this.investmentAccountColors = [];
        } else {
          const total = this.helperService.sumData(data);
          const colors = data.labels.map((_, index) => this.getColor('investmentAccount', index));

          this.investmentAccountColors = colors;
          this.investmentAccountChartData = data.labels.map((label, index) => ({
            category: label,
            percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          }));

          this.investmentAccountData = data.labels.map((label, index) => ({
            category: label,
            count: data.data[index],
            percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
            color: colors[index]
          }));

          // CHANGED: If total === 0, set to zero state
          if (total === 0) {
            this.investmentAccountChartData = [];
            this.investmentAccountData = this.getZeroInvestmentAccountData();
            this.investmentAccountColors = [];
          }
        }
      })
      .catch((err) => {
        console.error(`Error fetching investment account data of bot '${this.selectedBot}:`, err);
        this.investmentAccountChartData = [];
        this.investmentAccountData = this.getZeroInvestmentAccountData();
        this.investmentAccountColors = [];
      });
  }

  // CHANGED: Added zero state for investment account
  public getZeroInvestmentAccountData(): { category: string, count: number, percentage: number, color: string }[] {
    const defaultCategories = ['Yes', 'No']; // Assumed yes/no for having investment account
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('investmentAccount', index)
    }));
  }

  public fetchEmploymentStatusData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('EmploymentStatus');
    if (!this.selectedBot || !botKey) {
      // CHANGED: Set zero state
      this.employmentStatusChartData = [];
      this.employmentStatusData = this.getZeroEmploymentStatusData();
      this.employmentStatusColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        // CHANGED: Handle zero-data or error
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.employmentStatusChartData = [];
          this.employmentStatusData = this.getZeroEmploymentStatusData();
          this.employmentStatusColors = [];
        } else {
          const desiredCategories = ['Employed Full Time', 'Employed Part Time', 'Self Employed', 'Unemployed'];
          const filteredData: GraphData = {
            labels: [],
            data: []
          };

          desiredCategories.forEach(category => {
            const index = data.labels.indexOf(category);
            if (index !== -1) {
              filteredData.labels.push(category);
              filteredData.data.push(data.data[index]);
            } else {
              filteredData.labels.push(category);
              filteredData.data.push(0);
            }
          });

          const total = this.helperService.sumData(filteredData);
          const colors = filteredData.labels.map((_, index) => this.getColor('employmentStatus', index));

          this.employmentStatusColors = colors;
          this.employmentStatusChartData = filteredData.labels.map((label, index) => ({
            category: label,
            percentage: total === 0 ? 0 : Math.round((filteredData.data[index] / total) * 100)
          }));

          this.employmentStatusData = filteredData.labels.map((label, index) => ({
            category: label,
            count: filteredData.data[index],
            percentage: total === 0 ? 0 : Math.round((filteredData.data[index] / total) * 100),
            color: colors[index]
          }));

          // CHANGED: If total === 0, ensure zero state (already handled by pushing 0s)
        }
      })
      .catch((err) => {
        console.error(`Error fetching employment status data of bot: ${this.selectedBot}:`, err);
        this.employmentStatusChartData = [];
        this.employmentStatusData = this.getZeroEmploymentStatusData();
        this.employmentStatusColors = [];
      });
  }

  // CHANGED: Added zero state for employment status
  public getZeroEmploymentStatusData(): { category: string, count: number, percentage: number, color: string }[] {
    const defaultCategories = ['Employed Full Time', 'Employed Part Time', 'Self Employed', 'Unemployed'];
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('languageZero', index)
    }));
  }

  public fetchBEEIStatusData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('PYEICheck');
    if (!this.selectedBot || !botKey) {
      this.beeiStatusChartData = [];
      this.beeiStatusData = this.getZeroBEEIStatusData();
      this.beeiStatusColors = [];
      return Promise.resolve();
    }

    if (this.selectedBot === 'kitso') botKey = 'PYEICheck';

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.beeiStatusChartData = [];
          this.beeiStatusData = this.getZeroBEEIStatusData();
          this.beeiStatusColors = [];
          return;
        }
        const total = this.helperService.sumData(data);

        // Reorder: 'Yes' first, then 'No'
        const sortedIndices = data.labels
          .map((label, index) => ({ label, index }))
          .sort((a, b) => (a.label === 'Yes' ? -1 : b.label === 'Yes' ? 1 : 0))
          .map(item => item.index);

        const sortedLabels = sortedIndices.map(i => data.labels[i]);
        const sortedData = sortedIndices.map(i => data.data[i]);

        const colorMap: { [key: string]: string } = {
          'Yes': 'rgba(234, 51, 84, 1)',
          'No': 'rgba(53, 122, 246, 1)'
        };

        const colors = sortedLabels.map(label => colorMap[label] || this.getColor('beeiStatus', sortedLabels.indexOf(label)));
        this.beeiStatusColors = colors;

        this.beeiStatusChartData = sortedLabels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((sortedData[index] / total) * 100)
        }));

        this.beeiStatusData = sortedLabels.map((label, index) => ({
          category: label,
          count: sortedData[index],
          percentage: total === 0 ? 0 : Math.round((sortedData[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching BEEI status data of bot: ${this.selectedBot}:`, err);
        this.beeiStatusChartData = [];
        this.beeiStatusData = this.getZeroBEEIStatusData();
        this.beeiStatusColors = [];
      });
  }

  public getZeroBEEIStatusData(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['Yes', 'No'];
    const colorMap: { [key: string]: string } = {
      'Yes': 'rgb(168, 164, 165)',
      'No': 'rgb(168, 164, 165)'
    };
    return defaultCategories.map((cat) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: colorMap[cat]
    }));
  }

  public fetchYearKitsoData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('Year');
    if (!this.selectedBot || !botKey) {
      this.yearKitsoChartData = [];
      this.yearKitsoData = this.getZeroYearKitsoData();
      this.yearKitsoColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.yearKitsoChartData = [];
          this.yearKitsoData = this.getZeroYearKitsoData();
          this.yearKitsoColors = [];
          return;
        }

        const total = this.helperService.sumData(data);

        // Ensure '2025' appears first
        const sortedIndices = data.labels
          .map((label, index) => ({ label, index }))
          .sort((a, b) => (a.label === '2025' ? -1 : b.label === '2025' ? 1 : 0))
          .map(item => item.index);

        const sortedLabels = sortedIndices.map(i => data.labels[i]);
        const sortedData = sortedIndices.map(i => data.data[i]);

        const colorMap: { [key: string]: string } = {
          '2025': 'rgb(168, 164, 165)',
          '2022': 'rgb(168, 164, 165)'
        };

        const colors = sortedLabels.map(label => colorMap[label] || this.getColor('yearKitso', sortedLabels.indexOf(label)));
        this.yearKitsoColors = colors;

        this.yearKitsoChartData = sortedLabels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((sortedData[index] / total) * 100)
        }));

        this.yearKitsoData = sortedLabels.map((label, index) => ({
          category: label,
          count: sortedData[index],
          percentage: total === 0 ? 0 : Math.round((sortedData[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching year data for bot: ${this.selectedBot}:`, err);
        this.yearKitsoChartData = [];
        this.yearKitsoData = this.getZeroYearKitsoData();
        this.yearKitsoColors = [];
      });
  }

  public getZeroYearKitsoData(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['2025', '2022'];
    const colorMap: { [key: string]: string } = {
      '2025': 'rgb(168, 164, 165)',
      '2022': 'rgb(168, 164, 165)'
    };
    return defaultCategories.map((cat) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: colorMap[cat]
    }));
  }

  private fetchKitsoUserRoleData(start: string, end: string): Promise<void> {
    const botKey = this.getBotKey('UserRole');
    if (!this.selectedBot || !botKey) {
      this.kitsoUserRoleChartData = [];
      this.kitsoUserRoleData = this.getZeroKitsoUserRoleData();
      this.kitsoUserRoleColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.kitsoUserRoleChartData = [];
          this.kitsoUserRoleData = this.getZeroKitsoUserRoleData();
          this.kitsoUserRoleColors = [];
          return;
        }

        // === NEW MAPPING LOGIC ===
        const labelMap: { [key: string]: string } = {
          "Option 1": "Option 1:  Teacher",
          "Option 2": "Option 2:  Teacher's Assistant",
          "Option 3": "Option 3:  ECD Centre Owner or Teacher"
        };

        const mappedLabels = data.labels.map(label => labelMap[label] || label); // fallback in case of unexpected label

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, index) => this.getColor('language', index)); // keep original index for consistent colors

        this.kitsoUserRoleColors = colors;

        // Chart data (used by igx-pie-chart)
        this.kitsoUserRoleChartData = mappedLabels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100)
        }));

        // Full data for the list on the right
        this.kitsoUserRoleData = mappedLabels.map((label, index) => ({
          category: label,
          count: data.data[index],
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching Kitso User Role data for bot ${this.selectedBot}:`, err);
        this.kitsoUserRoleChartData = [];
        this.kitsoUserRoleData = this.getZeroKitsoUserRoleData();
        this.kitsoUserRoleColors = [];
      });
  }

  public getZeroKitsoUserRoleData(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = [
      "Option 1 Teacher",
      "Option 2 Teacher's Assistant",
      "Option 3 ECD Centre Owner or Teacher"
    ];

    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('kitsoUserRole', index)
    }));
  }



  public fetchOrganisationECDData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('OrganisationECD');

    if (!this.selectedBot || !botKey) {
      this.setOrganisationECDZeroState();
      return Promise.resolve();
    }


    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || !Array.isArray(data.labels) || data.labels.length === 0 || this.helperService.sumData(data) === 0) {
          this.setOrganisationECDZeroState();
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, i) => this.getColor('organisationECD', i));

        this.organisationECDColors = colors;

        this.organisationECDChartData = data.labels.map((label, i) => ({
          category: label,
          percentage: Math.round((data.data[i] / total) * 100)
        }));

        this.organisationECDData = data.labels.map((label, i) => ({
          category: label,
          count: data.data[i],
          percentage: Math.round((data.data[i] / total) * 100),
          color: colors[i]
        }));
      })
      .catch(err => {
        console.error('Organisation ECD fetch error:', err);
        this.setOrganisationECDZeroState();
      });
  }

  private setOrganisationECDZeroState(): void {
    const greyColor = 'rgba(179, 193, 221, 1)';
    const darkGrey = 'rgba(179, 193, 221, 1)';
    const defaults = ['Public School', 'Private School', 'NGO', 'Government', 'Other'];

    this.organisationECDColors = [...defaults.map(() => greyColor), darkGrey];

    this.organisationECDChartData = [
      ...defaults.map(cat => ({ category: cat, percentage: 0 })),
      { category: 'No Data', percentage: 100 }
    ];

    this.organisationECDData = [
      ...defaults.map(cat => ({ category: cat, count: 0, percentage: 0, color: greyColor })),
      { category: 'No Data', count: 0, percentage: 100, color: greyColor }
    ];
  }

  private fetchKitsoECDRoleChartData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('EcdRole');
    if (!this.selectedBot || !botKey) {
      this.kitsoECDRoleChartData = [];
      this.kitsoECDRoleData = this.getZeroKitsoECDRole();
      this.kitsoECDRoleColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.kitsoECDRoleChartData = [];
          this.kitsoECDRoleData = this.getZeroKitsoECDRole();
          this.kitsoECDRoleColors = [];
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, index) => this.getColor('kitsoECDRole', index));

        this.kitsoECDRoleColors = colors;

        this.kitsoECDRoleChartData = data.labels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100)
        }))

        this.kitsoECDRoleData = data.labels.map((label, index) => ({
          category: label,
          count: data.data[index],
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching Organisation ECD data for bot ${this.selectedBot}:`, err);
        this.kitsoECDRoleChartData = [];
        this.kitsoECDRoleData = this.getZeroKitsoECDRole();
        this.kitsoECDRoleColors = [];
      });
  }

  public getZeroEducationn(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['Public School', 'Private School', 'NGO', 'Government', 'Other'];
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('languageZero', index)
    }));
  }

  private fetchEducationData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('Education');
    if (!this.selectedBot || !botKey) {
      this.educationLwaziChartData = [];
      this.educationLwaziData = this.getZeroEducationn();
      this.educationLwaziColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.educationLwaziChartData = [];
          this.educationLwaziData = this.getZeroEducationn();
          this.educationLwaziColors = [];
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, index) => this.getColor('organisationECD', index));

        this.educationLwaziColors = colors;

        this.educationLwaziChartData = data.labels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100)
        }))

        this.educationLwaziData = data.labels.map((label, index) => ({
          category: label,
          count: data.data[index],
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching Organisation ECD data for bot ${this.selectedBot}:`, err);
        this.educationLwaziChartData = [];
        this.educationLwaziData = this.getZeroEducationn();
        this.educationLwaziColors = [];
      });
  }

  public getZeroKitsoECDRole(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['Public School', 'Private School', 'NGO', 'Government', 'Other'];
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('organisationECD', index)
    }));
  }


  private async fetchSentimentData(start: string, end: string): Promise<void> {
    const bot = 'lwazi';
    const sentimentKeys = ['Sentiment1', 'Sentiment2'];

    try {

      const requests = sentimentKeys.map(key =>
        this.supabaseService.getProfileData(bot, key, start, end).toPromise()
          .catch((err: any) => {
            console.warn(`API Error fetching ${key}:`, err);
            return { isError: true, status: err?.status };
          })
      );

      const [res1, res2] = await Promise.all(requests);

      this.sentiment1Data = this.transformSentimentData(res1, 'Sentiment1');
      this.sentiment2Data = this.transformSentimentData(res2, 'Sentiment2');
    } catch (err: any) {
      console.error("Critical error in fetchSentimentData:", err);
      this.sentiment1Data = this.getZeroStateData();
      this.sentiment2Data = this.getZeroStateData();
      this.error = "Failed to fetch sentiment data. Please try again.";
    }
  }

  /**
   * Helper to transform the API response or fallback to a Zero State
   */
  private transformSentimentData(response: any, key: string): { category: string, percentage: number }[] {
    let payload = response?.body ?? response;

    if (
      !payload ||
      !Array.isArray(payload.labels) ||
      payload.labels.length === 0 ||
      !Array.isArray(payload.data) ||
      payload.data.length !== payload.labels.length
    ) {
      console.warn(`Invalid or empty sentiment data for ${key}:`, payload);
      return this.getZeroStateData();
    }

    const apiData = payload;
    const total = apiData.data.reduce((acc: number, val: number) => acc + (Number(val) || 0), 0);

    if (total === 0) {
      console.warn(`Total count is zero for ${key} - showing zero state`);
      return this.getZeroStateData();
    }

    const transformed = apiData.labels.map((label: string, index: number) => {
      const value = Number(apiData.data[index]) || 0;
      const percentage = Math.round((value / total) * 100);
      return {
        category: label,
        percentage
      };
    });
    return transformed;
  }

  /**
   * Generates the default zero state data structure
   */
  private getZeroStateData(): { category: string, percentage: number }[] {
    return [
      { category: "Strongly agree", percentage: 0 },
      { category: "I don't know", percentage: 0 },
      { category: "I don't agree", percentage: 0 }
    ];
  }

  private fetchMaritalStatus(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('MaritalStatus');
    if (!this.selectedBot || !botKey) {
      this.maritalLwaziChartData = [];
      this.maritalLwaziData = this.getZeroMaritalStatus();
      this.maritalLwaziColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.maritalLwaziChartData = [];
          this.maritalLwaziData = this.getZeroMaritalStatus();
          this.maritalLwaziColors = [];
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, index) => this.getColor('language', index));

        this.maritalLwaziColors = colors;

        this.maritalLwaziChartData = data.labels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100)
        }))

        this.maritalLwaziData = data.labels.map((label, index) => ({
          category: label,
          count: data.data[index],
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching Organisation ECD data for bot ${this.selectedBot}:`, err);
        this.maritalLwaziChartData = [];
        this.maritalLwaziData = this.getZeroMaritalStatus();
        this.maritalLwaziColors = [];
      });
  }

  public getZeroMaritalStatus(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['Black African', 'Coloured', 'Indian/Asian', 'White', 'Other'];
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('organisationECD', index)
    }));
  }

  private fetchInstitutionData(start: string, end: string): Promise<void> {
    let botKey = 'Institution';
    if (!this.selectedBot || !botKey) {
      this.industryChartData = [];
      this.industryData = this.getZeroInstitution();
      this.industryColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.industryChartData = [];
          this.industryData = this.getZeroInstitution();
          this.industryColors = [];
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, index) => this.getColor('industry', index));

        this.industryColors = colors;

        this.industryChartData = data.labels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100)
        }))

        this.industryData = data.labels.map((label, index) => ({
          category: label,
          count: data.data[index],
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching Organisation ECD data for bot ${this.selectedBot}:`, err);
        this.industryChartData = [];
        this.industryData = this.getZeroInstitution();
        this.industryColors = [];
      });
  }

  public getZeroInstitution(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['TUT', 'Other', 'NedBank', 'MTN'];
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('organisationECD', index)
    }));
  }

  public getZeroCapitecRole(): { category: string; count: number; percentage: number; color: string }[] {
    const defaultCategories = ['Branch Manager', 'Assistant Branch Manager', 'Regional Manager'];
    return defaultCategories.map((cat, index) => ({
      category: cat,
      count: 0,
      percentage: 0,
      color: this.getColor('languageZero', index)
    }));
  }

  private fetchCapitecRoleData(start: string, end: string): Promise<void> {
    let botKey = this.getBotKey('Role');
    if (!this.selectedBot || !botKey) {
      this.capitecRoleChartData = [];
      this.capitecRoleData = this.getZeroCapitecRole();
      this.capitecRoleColors = [];
      return Promise.resolve();
    }

    return this.supabaseService.getProfileData(this.selectedBot, botKey, start, end).toPromise()
      .then((data: GraphData | undefined) => {
        if (!data || typeof data !== 'object' || !Array.isArray(data.labels) || !Array.isArray(data.data) || data.labels.length === 0 || (data as any).status === 'error') {
          if ((data as any)?.message) {
            this.error = (data as any).message;
          }
          this.capitecRoleChartData = [];
          this.capitecRoleData = this.getZeroCapitecRole();
          this.capitecRoleColors = [];
          return;
        }

        const total = this.helperService.sumData(data);
        const colors = data.labels.map((_, index) => this.getColor('organisationECD', index));

        this.capitecRoleColors = colors;

        this.capitecRoleChartData = data.labels.map((label, index) => ({
          category: label,
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100)
        }))

        this.capitecRoleData = data.labels.map((label, index) => ({
          category: label,
          count: data.data[index],
          percentage: total === 0 ? 0 : Math.round((data.data[index] / total) * 100),
          color: colors[index]
        }));
      })
      .catch((err) => {
        console.error(`Error fetching Capitec Role data for bot ${this.selectedBot}:`, err);
        this.capitecRoleChartData = [];
        this.capitecRoleData = this.getZeroCapitecRole();
        this.capitecRoleColors = [];
      });
  }

  public clearBreakdown(): void {
    this.genderData = [];
    this.ageData = [];
    this.educationData = [];
    this.incomeData = [];
    this.educationAssistantData = [];
    this.disabilityData = [];
  }

  public async loadTables(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    currentStart: string,
    currentEnd: string,
    prevStart: string,
    prevEnd: string
  ): Promise<void> {
    const tasks: (() => Promise<void>)[] = [];

    if (bot === 'lwazi') {
      tasks.push(() =>
        this.fetchTableData(
          'lwazi',
          'personal',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; } // Guard before setting
        )
      );
      tasks.push(() =>
        this.fetchTableData(
          'lwazi',
          'business',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.businessFinanceTableData = data; } // Guard before setting
        )
      );
    } else if (bot === 'lesedi') {
      tasks.push(() =>
        this.fetchTableData(
          'lesedi',
          'path1',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; } // Guard before setting
        )
      );
      tasks.push(() =>
        this.fetchTableData(
          'lesedi',
          'path2',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.businessFinanceTableData = data; }
        )
      );
    }
    if (bot === 'kitso') {
      tasks.push(() =>
        this.fetchTableData(
          'kitso',
          'path1',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; } // Guard before setting
        )
      );
    }
    if (bot === 'kitsoecd') {
      tasks.push(() =>
        this.fetchTableData(
          'kitsoecd',
          'path1',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; }
        ))
    }
    if (bot === 'kitsozazi') {
      tasks.push(() =>
        this.fetchTableData(
          'kitsozazi',
          'path1',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; }
        ))
    }
    if (bot === 'kitsoai') {
      tasks.push(() =>
        this.fetchTableData(
          'kitsoai',
          'path1',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; }
        ));
      tasks.push(() =>
        this.fetchTableData(
          'kitsoai',
          'path2',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.businessFinanceTableData = data; }
        ));
    }
    if (bot === 'mpilo') {
      tasks.push(() =>
        this.fetchTableData(
          'mpilo',
          'path1',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.personalFinanceTableData = data; }
        )
      );
      tasks.push(() =>
        this.fetchTableData(
          'mpilo',
          'path2',
          currentStart,
          currentEnd,
          prevStart,
          prevEnd,
          data => { if (this.selectedBot === bot) this.businessFinanceTableData = data; }
        )
      );
    }
    // Execute tasks sequentially to avoid concurrent fetchTableData calls
    for (const task of tasks) {
      await task();
      if (this.selectedBot !== bot) return;
    }
  }

  public async fetchTableData(
    bot: 'lwazi' | 'lesedi' | 'kitso' | 'kitsoecd' | 'kitsozazi' | 'kitsoai' | 'mpilo',
    type: 'personal' | 'business' | 'path1' | 'path2',
    currentStart: string,
    currentEnd: string,
    prevStart: string,
    prevEnd: string,
    callback: (data: CompletionTableData[]) => void,
    tableTitle?: string
  ): Promise<void> {
    if (!this.validBotTypes[bot]?.includes(type)) {
      console.error(`Invalid bot/type combination: ${bot}/${type}`);
      this.error = `Invalid data type for ${bot}. Please select a valid option.`;
      callback([]);
      return;
    }

    try {
      const results = await this.supabaseService.getCompletionStats(bot, type, currentStart, currentEnd).toPromise()
        .then(currentCombined => {
          return this.supabaseService.getCompletionStats(bot, type, prevStart, prevEnd).toPromise()
            .then(previousCombined => ({ currentCombined, previousCombined }));
        })

      // Assign default values to handle undefined cases
      const currentCombinedArray = results.currentCombined || [];
      const previousCombinedArray = results.previousCombined || [];

      const previousMap = new Map(
        previousCombinedArray.map(course => [course.course_name, course])
      );

      // Create course-specific data
      const courseData: CompletionTableData[] = currentCombinedArray.map(course => {
        const prevCourse = previousMap.get(course.course_name);
        const courseChange = this.helperService.calculateChange(
          { labels: [course.course_name], data: [course.students_completed] },
          { labels: [course.course_name], data: [prevCourse?.students_completed || 0] }
        );
        const quizChange = this.helperService.calculateChange(
          { labels: [course.course_name], data: [course.quiz_completed || 0] },
          { labels: [course.course_name], data: [prevCourse?.quiz_completed || 0] }
        );

        return {
          name: course.course_name || 'N/A',
          course_completion: course.students_completed || 0,
          course_change_class: courseChange.class || '',
          course_change_icon: courseChange.icon || '',
          course_change_percentage: courseChange.percentage !== 'N/A' ? courseChange.percentage : '0.0',
          quiz_completion: course.quiz_completed || 0,
          quiz_change_class: quizChange.class || '',
          quiz_change_icon: quizChange.icon || '',
          quiz_change_percentage: quizChange.percentage !== 'N/A' ? quizChange.percentage : '0.0',
          students_started: course.students_started || 0
        };
      });

      // Combine course data, heading row, and total row
      const data: CompletionTableData[] = [...courseData];

      callback(data);
    } catch (err) {
      console.error(`Error fetching ${bot}/${type} table data:`, err);
      this.error = `Failed to fetch ${bot}/${type} table data. Please try again.`;
      callback([]);
    }
  }

  public formatDate(date: Date): string {
    if (!date) {
      return ''; 
    }

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  public clearData(): void {
    this.enrolledUsersChartData = [];
    this.enrolledUsersTotal = 0;
    this.enrolledUsersChangePercentage = '';
    this.enrolledUsersChangeClass = '';
    this.enrolledUsersChangeIcon = '';
    this.courseCompletionsChartData = [];
    this.courseCompletionsTotal = 0;
    this.courseCompletionsChangePercentage = '';
    this.courseCompletionsChangeClass = '';
    this.courseCompletionsChangeIcon = '';
    this.usersBeganCourseChartData = [];
    this.usersBeganCourseTotal = 0;
    this.usersBeganCourseChangePercentage = '';
    this.usersBeganCourseChangeClass = '';
    this.usersBeganCourseChangeIcon = '';
    this.completionRateChartData = [];
    this.completionRateTotal = 0;
    this.completionRateChangePercentage = '';
    this.completionRateChangeClass = '';
    this.completionRateChangeIcon = '';
    this.personalFinanceTableData = [];
    this.businessFinanceTableData = [];
    this.genderData = [];
    this.ageData = [];
    this.educationData = [];
    this.incomeData = [];
    this.countryData = [];
    this.mapDots = [];
    this.languageIndexData = [];
    this.prePostQuizQuestionsIndexData = [];
    this.preQuizScores = [];
    this.postQuizScores = [];
    this.overAllEngagementQuizScores = [];
    this.dropOffScores = [];
    this.overAllEngagementQuizScores = [];
    this.countryData = [];
    this.countryIndexData = [];
    this.provinceIndexData = [];
    this.selectedProvince = [];
    this.provinceMonthlyData = null;
    this.provinceColors = [];
    this.industryChartData = [];
    this.industryColors = [];
    this.employmentChartData = [];
    this.employmentData = [];
    this.raceChartData = [];
    this.raceData = [];
    this.employmentColors = [];
    this.raceColors = [];
    this.locationChartData = [];
    this.locationData = [];
    this.locationColors = [];
    this.bankAccountChartData = [];
    this.bankAccountData = [];
    this.bankAccountColors = [];
    this.investmentAccountChartData = [];
    this.investmentAccountData = [];
    this.investmentAccountColors = [];
    this.employmentStatusChartData = [];
    this.employmentStatusData = [];
    this.employmentStatusColors = [];
    this.yearKitsoChartData = [];
    this.yearKitsoData = [];
    this.yearKitsoColors = [];
    this.beeiStatusChartData = [];
    this.beeiStatusData = [];
    this.beeiStatusColors = [];
    this.educationAssistantData = [];
    this.selectedEducationAssistant = null;
    this.disabilityData = [];
    this.ethnicityCheckData = [];
    this.ethnicityCheckChartData = [];
    this.ethnicityCheckColors = [];
    this.prePostQuizQuestionsIndexData = [];
    this.preQuizScores = [];
    this.postQuizScores = [];
    this.dropOffScores = [];
    this.overAllEngagementQuizScores = [];
    this.prePostQuizQuestionsIndexData = [];
    this.totalParticipants = 0;
    this.totalAverage = 0;
    this.improvement = 0;
    this.mAndEResponses = [];
    this.currentPeriodStats = [];
    this.participationRate = 0;
    this.kitsoUserRoleChartData = [];
    this.kitsoUserRoleData = [];
    this.kitsoUserRoleColors = [];
    this.organisationECDChartData = [];
    this.organisationECDData = [];
    this.organisationECDColors = [];
    this.kitsoECDRoleChartData = [];
    this.kitsoECDRoleData = [];
    this.kitsoECDRoleColors = [];
    this.mAndEConfigArray = [];
    this.overAllEngagementChartData = null;
    this.preQuizScoresChartData = null;
    this.postQuizScoresChartData = null;
    this.dropOffChartData = null;
    this.prePostQuizQuestionsChartData = null;
    this.languageChartData = null;
    this.provinceChartData = null;
    this.educationLwaziChartData = [];
    this.educationLwaziData = [];
    this.educationLwaziColors = [];
    this.countryChartData = [];
    this.countryData = [];
    this.countryColors = [];
    this.mAndEChartData = null;
    this.languageChartData = null;
    this.provinceChartData = null;
    this.currentPeriodStats = [];
    this.participationRate = 0;
    this.personalCurrentPeriodStats = [];
    this.businessCurrentPeriodStats = [];
    this.currentParticipation = null;
    this.trendPercentage = 0;
    this.totalAverage = 0;
    this.totalParticipants = 0;
    this.mAndEConfig = [];
    this.languageChartData = null;
    this.provinceChartData = null;
    this.mAndEAverages = [];
    this.mAndEAveragesTotal = 0;
    this.fullMAndEAverages = [];
    this.businessMAndEConfigArray = [];
    this.personalMAndEConfigArray = [];
    this.businessMAndEConfigArray = [];
    this.personalMAndEConfigArray = [];
    this.personalMAndEChart = [];
    this.personalTotalAverage = 0;
    this.businessTotalAverage = 0;
    this.personalTotalParticipants = 0;
    this.businessTotalParticipants = 0;
    this.personalTrendPercentage = 0;
    this.businessTrendPercentage = 0;
    this.businessCurrentParticipation = null;
    this.personalCurrentParticipation = null;
    this.businessTrendColor = '';
    this.personalTrendColor = '';

    this.lesediPath1UsersBeganCourseTotal = 0;
    this.lesediPath1UsersBeganCourseChangePercentage = '';
    this.lesediPath1UsersBeganCourseChangeIcon = 'remove';
    this.lesediPath1UsersBeganCourseChangeClass = 'neutral';
    this.lesediPath1CourseCompletionsTotal = 0;
    this.lesediPath1CourseCompletionsChangePercentage = '';
    this.lesediPath1CourseCompletionsChangeIcon = 'remove';
    this.lesediPath1CourseCompletionsChangeClass = 'neutral';
    this.lesediPath1CompletionRateTotal = 0;
    this.lesediPath1CompletionRateChangePercentage = '';
    this.lesediPath1CompletionRateChangeIcon = 'remove';
    this.lesediPath1CompletionRateChangeClass = 'neutral';
    this.lesediPath2UsersBeganCourseTotal = 0;
    this.lesediPath2UsersBeganCourseChangePercentage = '';
    this.lesediPath2UsersBeganCourseChangeIcon = 'remove';
    this.lesediPath2UsersBeganCourseChangeClass = 'neutral';
    this.lesediPath2CourseCompletionsTotal = 0;
    this.lesediPath2CourseCompletionsChangePercentage = '';
    this.lesediPath2CourseCompletionsChangeIcon = 'remove';
    this.lesediPath2CourseCompletionsChangeClass = 'neutral';
    this.lesediPath2CompletionRateTotal = 0;
    this.lesediPath2CompletionRateChangePercentage = '';
    this.lesediPath2CompletionRateChangeIcon = 'remove';
    this.lesediPath2CompletionRateChangeClass = 'neutral';
    this.lesediPath1CurrentPeriodStats = [];
    this.lesediPath2CurrentPeriodStats = [];
    this.lesediPath1MAndEResponses = [];
    this.lesediPath2MAndEResponses = [];
    this.lesediPath1MAndEAverages = [];
    this.lesediPath2MAndEAverages = [];
    this.lesediPath1MAndEChart = null;
    this.lesediPath2MAndEChart = null;
    this.lesediPath1TotalParticipants = 0;
    this.lesediPath1TotalAverage = 0;
    this.lesediPath1TrendPercentage = 0;
    this.lesediPath1TrendColor = '';
    this.lesediPath1CurrentParticipation = null;
    this.lesediPath1CurrentMonthMAndE = 0;
    this.lesediPath1MAndEConfigArray = [];
    this.lesediPath2TotalParticipants = 0;
    this.lesediPath2TotalAverage = 0;
    this.lesediPath2TrendPercentage = 0;
    this.lesediPath2TrendColor = '';
    this.lesediPath2CurrentParticipation = null;
    this.lesediPath2CurrentMonthMAndE = 0;
    this.lesediPath2MAndEConfigArray = [];
    this.lesediPath1PrePostChartData = null;
    this.lesediPath2PrePostChartData = null;
    this.lesediPath1PrePostQuizQuestionsIndexData = [];
    this.lesediPath2PrePostQuizQuestionsIndexData = [];
    this.lesediPath1PreQuizScoresChartData = null;
    this.lesediPath1PostQuizScoresChartData = null;
    this.lesediPath1OverAllEngagementChartData = null;
    this.lesediPath1DropOffChartData = null;
    this.lesediPath2PreQuizScoresChartData = null;
    this.lesediPath2PostQuizScoresChartData = null;
    this.lesediPath2OverAllEngagementChartData = null;
    this.lesediPath2DropOffChartData = null;

    this.kitsoaiPath1UsersBeganCourseTotal = 0;
    this.kitsoaiPath1UsersBeganCourseChangePercentage = '';
    this.kitsoaiPath1UsersBeganCourseChangeIcon = 'remove';
    this.kitsoaiPath1UsersBeganCourseChangeClass = 'neutral';
    this.kitsoaiPath1CourseCompletionsTotal = 0;
    this.kitsoaiPath1CourseCompletionsChangePercentage = '';
    this.kitsoaiPath1CourseCompletionsChangeIcon = 'remove';
    this.kitsoaiPath1CourseCompletionsChangeClass = 'neutral';
    this.kitsoaiPath1CompletionRateTotal = 0;
    this.kitsoaiPath1CompletionRateChangePercentage = '';
    this.kitsoaiPath1CompletionRateChangeIcon = 'remove';
    this.kitsoaiPath1CompletionRateChangeClass = 'neutral';
    this.kitsoaiPath2UsersBeganCourseTotal = 0;
    this.kitsoaiPath2UsersBeganCourseChangePercentage = '';
    this.kitsoaiPath2UsersBeganCourseChangeIcon = 'remove';
    this.kitsoaiPath2UsersBeganCourseChangeClass = 'neutral';
    this.kitsoaiPath2CourseCompletionsTotal = 0;
    this.kitsoaiPath2CourseCompletionsChangePercentage = '';
    this.kitsoaiPath2CourseCompletionsChangeIcon = 'remove';
    this.kitsoaiPath2CourseCompletionsChangeClass = 'neutral';
    this.kitsoaiPath2CompletionRateTotal = 0;
    this.kitsoaiPath2CompletionRateChangePercentage = '';
    this.kitsoaiPath2CompletionRateChangeIcon = 'remove';
    this.kitsoaiPath2CompletionRateChangeClass = 'neutral';
    this.kitsoaiPath1CurrentPeriodStats = [];
    this.kitsoaiPath2CurrentPeriodStats = [];
    this.kitsoaiPath1MAndEResponses = [];
    this.kitsoaiPath2MAndEResponses = [];
    this.kitsoaiPath1MAndEAverages = [];
    this.kitsoaiPath2MAndEAverages = [];
    this.kitsoaiPath1MAndEChart = null;
    this.kitsoaiPath2MAndEChart = null;
    this.kitsoaiPath1TotalParticipants = 0;
    this.kitsoaiPath1TotalAverage = 0;
    this.kitsoaiPath1TrendPercentage = 0;
    this.kitsoaiPath1TrendColor = '';
    this.kitsoaiPath1CurrentParticipation = null;
    this.kitsoaiPath1CurrentMonthMAndE = 0;
    this.kitsoaiPath1MAndEConfigArray = [];
    this.kitsoaiPath2TotalParticipants = 0;
    this.kitsoaiPath2TotalAverage = 0;
    this.kitsoaiPath2TrendPercentage = 0;
    this.kitsoaiPath2TrendColor = '';
    this.kitsoaiPath2CurrentParticipation = null;
    this.kitsoaiPath2CurrentMonthMAndE = 0;
    this.kitsoaiPath2MAndEConfigArray = [];
    this.kitsoaiPath1PrePostChartData = null;
    this.kitsoaiPath2PrePostChartData = null;
    this.kitsoaiPath1PrePostQuizQuestionsIndexData = [];
    this.kitsoaiPath2PrePostQuizQuestionsIndexData = [];
    this.kitsoaiPath1PreQuizScoresChartData = null;
    this.kitsoaiPath1PostQuizScoresChartData = null;
    this.kitsoaiPath1OverAllEngagementChartData = null;
    this.kitsoaiPath1DropOffChartData = null;
    this.kitsoaiPath2PreQuizScoresChartData = null;
    this.kitsoaiPath2PostQuizScoresChartData = null;
    this.kitsoaiPath2OverAllEngagementChartData = null;
    this.kitsoaiPath2DropOffChartData = null;

    this.mpiloPath1UsersBeganCourseTotal = 0;
    this.mpiloPath1UsersBeganCourseChangePercentage = '';
    this.mpiloPath1UsersBeganCourseChangeIcon = 'remove';
    this.mpiloPath1UsersBeganCourseChangeClass = 'neutral';
    this.mpiloPath1CourseCompletionsTotal = 0;
    this.mpiloPath1CourseCompletionsChangePercentage = '';
    this.mpiloPath1CourseCompletionsChangeIcon = 'remove';
    this.mpiloPath1CourseCompletionsChangeClass = 'neutral';
    this.mpiloPath1CompletionRateTotal = 0;
    this.mpiloPath1CompletionRateChangePercentage = '';
    this.mpiloPath1CompletionRateChangeIcon = 'remove';
    this.mpiloPath1CompletionRateChangeClass = 'neutral';
    this.mpiloPath2UsersBeganCourseTotal = 0;
    this.mpiloPath2UsersBeganCourseChangePercentage = '';
    this.mpiloPath2UsersBeganCourseChangeIcon = 'remove';
    this.mpiloPath2UsersBeganCourseChangeClass = 'neutral';
    this.mpiloPath2CourseCompletionsTotal = 0;
    this.mpiloPath2CourseCompletionsChangePercentage = '';
    this.mpiloPath2CourseCompletionsChangeIcon = 'remove';
    this.mpiloPath2CourseCompletionsChangeClass = 'neutral';
    this.mpiloPath2CompletionRateTotal = 0;
    this.mpiloPath2CompletionRateChangePercentage = '';
    this.mpiloPath2CompletionRateChangeIcon = 'remove';
    this.mpiloPath2CompletionRateChangeClass = 'neutral';
    this.mpiloPath1CurrentPeriodStats = [];
    this.mpiloPath2CurrentPeriodStats = [];
    this.mpiloPath1MAndEResponses = [];
    this.mpiloPath2MAndEResponses = [];
    this.mpiloPath1MAndEAverages = [];
    this.mpiloPath2MAndEAverages = [];
    this.mpiloPath1MAndEChart = null;
    this.mpiloPath2MAndEChart = null;
    this.mpiloPath1TotalParticipants = 0;
    this.mpiloPath1TotalAverage = 0;
    this.mpiloPath1TrendPercentage = 0;
    this.mpiloPath1TrendColor = '';
    this.mpiloPath1CurrentParticipation = null;
    this.mpiloPath1CurrentMonthMAndE = 0;
    this.mpiloPath1MAndEConfigArray = [];
    this.mpiloPath2TotalParticipants = 0;
    this.mpiloPath2TotalAverage = 0;
    this.mpiloPath2TrendPercentage = 0;
    this.mpiloPath2TrendColor = '';
    this.mpiloPath2CurrentParticipation = null;
    this.mpiloPath2CurrentMonthMAndE = 0;
    this.mpiloPath2MAndEConfigArray = [];
    this.mpiloPath1PrePostChartData = null;
    this.mpiloPath2PrePostChartData = null;
    this.mpiloPath1PrePostQuizQuestionsIndexData = [];
    this.mpiloPath2PrePostQuizQuestionsIndexData = [];
    this.mpiloPath1PreQuizScoresChartData = null;
    this.mpiloPath1PostQuizScoresChartData = null;
    this.mpiloPath1OverAllEngagementChartData = null;
    this.mpiloPath1DropOffChartData = null;
    this.mpiloPath2PreQuizScoresChartData = null;
    this.mpiloPath2PostQuizScoresChartData = null;
    this.mpiloPath2OverAllEngagementChartData = null;
    this.mpiloPath2DropOffChartData = null;
    this.resetMoodAnalytics();
  }
}